// /* ==========================================================================
//    LUXURY PRODUCT PAGE JAVASCRIPT (Optimized Video Playback)
//    Replaces existing IIFE. Keeps same public functions: openCartDrawer, renderCartItems, etc.
//    ========================================================================== */
// (function () {
//   "use strict";

//   // Quick CSS tweaks to help video rendering (will-create compositing layer)
//   const style = document.createElement("style");
//   style.innerHTML = `
//     .lux-slide-video,
//     .lux-zoom-video {
//       backface-visibility: hidden;
//       -webkit-backface-visibility: hidden;
//       transform: translateZ(0);
//       will-change: transform, opacity;
//       object-fit: cover;
//       width: 100%;
//       height: 100%;
//       display: block;
//       max-height: 100%;
//       opacity: 1;
//     }
//     .lux-zoom-video, .lux-slide-video { opacity: 0; }
//     .lux-zoom-image {
//       will-change: transform;
//     }
//   `;
//   document.head.appendChild(style);

//   // Helpers
//   const raf = (fn) => requestAnimationFrame(fn);
//   const once = (el, evt, cb) => el.addEventListener(evt, cb, { once: true });

//   // Video caching helpers: Cache Storage + blob URL reuse
//   const videoCacheName = "luxury-video-cache-v1";
//   const blobUrlMap = new Map();

//   async function cacheVideoResource(url) {
//     if (!url || typeof url !== "string") return;
//     // skip HLS playlists (.m3u8)
//     if (isHLSUrl(url)) {
//       console.debug("lux video: skipping cache for HLS URL", url);
//       return;
//     }
//     if (!("caches" in window)) return;
//     try {
//       const cache = await caches.open(videoCacheName);
//       const matched = await cache.match(url);
//       if (matched) return; // already cached
//       const resp = await fetch(url, { mode: "cors" });
//       if (!resp || !resp.ok) return;
//       await cache.put(url, resp.clone());
//     } catch (err) {
//       // Ignore cache failures (private mode, CORS, etc.)
//       console.warn("Video cache failed for", url, err);
//     }
//   }

//   async function getCachedBlobUrl(url) {
//     if (!url || typeof url !== "string") return null;
//     // never return blob URL for HLS playlists
//     if (isHLSUrl(url)) return null;
//     if (blobUrlMap.has(url)) return blobUrlMap.get(url);
//     if (!("caches" in window)) return null;
//     try {
//       const cache = await caches.open(videoCacheName);
//       const matched = await cache.match(url);
//       if (!matched) return null;
//       const blob = await matched.blob();
//       const blobUrl = URL.createObjectURL(blob);
//       blobUrlMap.set(url, blobUrl);
//       return blobUrl;
//     } catch (err) {
//       console.warn("getCachedBlobUrl error", err);
//       return null;
//     }
//   }

//   // Cached modal video to avoid decoder re-creation
//   let cachedModalVideo = null;

//   // Swiper reference (if used)
//   let mainSwiper = null;
//   // Detect iOS (including iPad with touch) — iOS Safari has known issues with blob URL
//   const isIOS = (() => {
//     try {
//       return (
//         /iP(ad|hone|od)/.test(navigator.userAgent) ||
//         (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
//       );
//     } catch (e) {
//       return false;
//     }
//   })();

//   // HLS detection: don't cache or convert m3u8 playlists to blob URLs
//   function isHLSUrl(url) {
//     try {
//       if (!url || typeof url !== "string") return false;
//       return url.indexOf(".m3u8") !== -1 || /(^|\/)hls(\/|$)/i.test(url);
//     } catch (e) {
//       return false;
//     }
//   }

//   // Tracks product object expected on window.luxuryProduct: { media: [{type:'image'|'video', url, previewUrl, alt}, ...], ... }
//   function init() {
//     if (document.readyState === "loading") {
//       document.addEventListener("DOMContentLoaded", bootstrap);
//     } else {
//       bootstrap();
//     }
//   }

//   function bootstrap() {
//     initSwiper();
//     initThumbnails();
//     initVariants();
//     initTabs();
//     initSizeGuide();
//     initZoomModal();
//     initAddToCart();
//     // Warm cache: attempt to cache the first product video (LCP) in background
//     try {
//       const product = window.luxuryProduct;
//       if (product && Array.isArray(product.media)) {
//         const firstVideo = product.media.find((m) => m.type === "video");
//         if (firstVideo && firstVideo.url) {
//           // cache the primary URL and any additional sources if present
//           cacheVideoResource(firstVideo.url);
//           if (firstVideo.sources && Array.isArray(firstVideo.sources)) {
//             firstVideo.sources.forEach((s) => cacheVideoResource(s.url));
//           }
//         }
//       }
//     } catch (e) {
//       // ignore
//     }
//     // Expose useful methods for other theme code
//     window.renderCartItems = renderCartItems;
//     window.openCartDrawer = openCartDrawer;
//     window.closeCartDrawer = closeCartDrawer;
//     window.luxuryProduct = window.luxuryProduct || window.luxuryProduct;
//   }

//   /* --------------------------------------------------------------------------
//      Swiper-like minimal integration (keeps behavior from your original code)
//      - If you use Swiper library, this will integrate with it; otherwise
//        it provides graceful behavior when Swiper is absent.
//      -------------------------------------------------------------------------- */
//   function initSwiper() {
//     const swiperEl = document.getElementById("productMainSwiper");
//     if (!swiperEl) return;

//     // If Swiper exists, initialize with observers disabled for stable video performance.
//     if (typeof Swiper !== "undefined") {
//       raf(() =>
//         raf(() => {
//           try {
//             mainSwiper = new Swiper("#productMainSwiper", {
//               slidesPerView: 1,
//               spaceBetween: 0,
//               speed: 300,
//               allowTouchMove: true,
//               centeredSlides: false,
//               loop: false,
//               watchOverflow: true,
//               observer: true,
//               observeParents: true,
//               resizeObserver: true,
//               preloadImages: false,
//               lazy: false,
//               on: {
//                 init() {
//                   this.update();
//                 },
//                 slideChange() {
//                   syncSlideVideoPlayback(this.activeIndex);
//                   updateThumbnails(this.activeIndex);
//                 },
//               },
//             });
//             // Ensure video state matches initial slide
//             syncSlideVideoPlayback(mainSwiper.activeIndex || 0);
//           } catch (e) {
//             console.warn("Swiper init failed:", e);
//           }
//         }),
//       );
//     } else {
//       // If no Swiper, fallback: bind click to open zoom and use index 0
//       swiperEl.addEventListener("click", function (e) {
//         if (
//           e.target.classList.contains("lux-slide-image") ||
//           e.target.classList.contains("lux-slide-video")
//         ) {
//           openZoomModal(0);
//         }
//       });
//     }
//   }

//   /* --------------------------------------------------------------------------
//      Thumbnails (same behavior, update active class and optionally open zoom on mobile)
//      -------------------------------------------------------------------------- */
//   function initThumbnails() {
//     const thumbnails = document.querySelectorAll("[data-thumbnail-index]");
//     thumbnails.forEach((thumb) => {
//       thumb.addEventListener("click", function () {
//         const index = parseInt(this.dataset.thumbnailIndex);
//         if (mainSwiper && typeof mainSwiper.slideTo === "function") {
//           mainSwiper.slideTo(index);
//         } else {
//           updateThumbnails(index);
//         }
//         if (window.innerWidth < 768) openZoomModal(index);
//       });
//     });
//   }

//   function updateThumbnails(activeIndex) {
//     const thumbnails = document.querySelectorAll("[data-thumbnail-index]");
//     thumbnails.forEach((thumb, idx) =>
//       thumb.classList.toggle("active", idx === activeIndex),
//     );
//   }

//   /* --------------------------------------------------------------------------
//      Variant selection (unchanged logic but safer DOM queries)
//      -------------------------------------------------------------------------- */
//   function initVariants() {
//     const variantButtons = document.querySelectorAll("[data-variant-btn]");
//     const variantIdInput = document.querySelector("[data-variant-id]");
//     const priceElement = document.querySelector("[data-product-price]");

//     variantButtons.forEach((button) => {
//       button.addEventListener("click", function () {
//         const variantId = this.dataset.variantId;
//         const variantPrice = this.dataset.variantPrice;
//         const isAvailable = this.dataset.variantAvailable === "true";

//         variantButtons.forEach((btn) => {
//           btn.classList.remove("selected");
//           const glow = btn.querySelector(".lux-variant-glow");
//           if (glow) glow.remove();
//         });

//         this.classList.add("selected");
//         const glow = document.createElement("span");
//         glow.className = "lux-variant-glow";
//         this.appendChild(glow);

//         if (variantIdInput) variantIdInput.value = variantId;
//         if (priceElement) priceElement.textContent = variantPrice;

//         updateActionButton(isAvailable);

//         // update URL param (no reload)
//         const url = new URL(window.location);
//         url.searchParams.set("variant", variantId);
//         window.history.replaceState({}, "", url);
//       });
//     });
//     // Evaluate availability on init (if there are no sizes, disable action buttons)
//     evaluateVariantAvailability();
//   }

//   function evaluateVariantAvailability() {
//     const variantButtons = Array.from(document.querySelectorAll("[data-variant-btn]"));
//     // If no variant buttons exist at all, treat as unavailable
//     if (!variantButtons.length) {
//       updateActionButton(false);
//       return;
//     }

//     // If a variant is already selected, use its availability
//     const selected = document.querySelector("[data-variant-btn].selected");
//     if (selected) {
//       const selAvailable = selected.dataset.variantAvailable === "true" && !selected.classList.contains("unavailable");
//       updateActionButton(!!selAvailable);
//       return;
//     }

//     // Otherwise, if any variant is available, enable buttons (choose first available), else disable
//     const anyAvailable = variantButtons.some((btn) => btn.dataset.variantAvailable === "true" && !btn.classList.contains("unavailable"));
//     updateActionButton(!!anyAvailable);
//   }

//   function updateActionButton(isAvailable) {
//     const addToCartBtn = document.querySelector("[data-add-to-cart]");
//     const buyNowBtn = document.querySelector("[data-buy-now-btn]");

//     const setDisabled = (el, disabled) => {
//       if (!el) return;
//       el.disabled = !!disabled;
//       if (disabled) {
//         el.setAttribute("aria-disabled", "true");
//         el.classList.add("disabled");
//       } else {
//         el.removeAttribute("aria-disabled");
//         el.classList.remove("disabled");
//       }
//     };

//     setDisabled(addToCartBtn, !isAvailable);
//     setDisabled(buyNowBtn, !isAvailable);
//   }

//   /* --------------------------------------------------------------------------
//      Tabs
//      -------------------------------------------------------------------------- */
//   function initTabs() {
//     const tabButtons = document.querySelectorAll("[data-tab]");
//     const tabPanels = document.querySelectorAll("[data-tab-panel]");

//     tabButtons.forEach((button) => {
//       button.addEventListener("click", function () {
//         const tabId = this.dataset.tab;
//         tabButtons.forEach((btn) => btn.classList.remove("active"));
//         this.classList.add("active");
//         tabPanels.forEach((panel) =>
//           panel.classList.toggle("active", panel.dataset.tabPanel === tabId),
//         );
//       });
//     });
//   }

//   /* --------------------------------------------------------------------------
//      Size Guide unit toggle (unchanged core)
//      -------------------------------------------------------------------------- */
// function initSizeGuide() {
//   const unitToggle = document.querySelector("[data-unit-toggle]");
//   if (!unitToggle) return;

//   let currentUnit = "cm";
//   const parent = unitToggle.parentElement;

//   unitToggle.addEventListener("click", function () {
//     currentUnit = currentUnit === "cm" ? "in" : "cm";

//     const isInch = currentUnit === "in";
//     this.classList.toggle("inch", isInch);

//     // reset labels
//     parent.querySelectorAll(".lux-unit-label").forEach(label => {
//       label.classList.remove("active");
//     });

//     // 🔥 INVERTED LOGIC
//     const activeUnit = currentUnit === "cm" ? "in" : "cm";
//     parent.querySelector(`[data-unit="${activeUnit}"]`)?.classList.add("active");

//     updateMeasurements(currentUnit);
//   });
// }
//   function updateMeasurements(unit) {
//     const cells = document.querySelectorAll("[data-cm]");
//     cells.forEach((cell) => {
//       const cmValue = parseFloat(cell.dataset.cm);
//       if (isNaN(cmValue)) return;
//       if (unit === "in") {
//         const inValue = (cmValue / 2.54).toFixed(1);
//         cell.textContent = inValue + "in";
//       } else {
//         cell.textContent = cmValue.toFixed(1) + "cm";
//       }
//     });
//   }

//   /* --------------------------------------------------------------------------
//      Image / Video Zoom Modal
//      - Reuses one cached modal video element to avoid repeated decoder allocations
//      - When a video slide is active in the product area, we attempt to play it muted/inline
//      -------------------------------------------------------------------------- */
//   let currentZoomIndex = 0;
//   let zoomScale = 1;
//   let zoomTranslate = { x: 0, y: 0 };
//   let isPanning = false;
//   let lastTouchDistance = null;

//   function initZoomModal() {
//     const modal = document.getElementById("imageZoomModal");
//     if (!modal) return;

//     const overlay = modal.querySelector(".lux-zoom-overlay");
//     const closeBtn = modal.querySelector(".lux-zoom-close");
//     const prevBtn = modal.querySelector(".lux-zoom-prev");
//     const nextBtn = modal.querySelector(".lux-zoom-next");
//     const imageWrapper = document.getElementById("zoomImageWrapper");

//     // Ensure the wrapper allows horizontal pan gestures so child thumbnails can scroll.
//     try {
//       if (imageWrapper) imageWrapper.style.touchAction = "auto";
//     } catch (e) {}

//     overlay && overlay.addEventListener("click", closeZoomModal);
//     closeBtn && closeBtn.addEventListener("click", closeZoomModal);

//     prevBtn &&
//       prevBtn.addEventListener("click", function (e) {
//         e.stopPropagation();
//         navigateZoom(-1);
//       });
//     nextBtn &&
//       nextBtn.addEventListener("click", function (e) {
//         e.stopPropagation();
//         navigateZoom(1);
//       });

//     document.addEventListener("keydown", function (e) {
//       if (!modal.classList.contains("active")) return;
//       if (e.key === "Escape") closeZoomModal();
//       if (e.key === "ArrowLeft") navigateZoom(-1);
//       if (e.key === "ArrowRight") navigateZoom(1);
//     });

//     if (imageWrapper) {
//       imageWrapper.addEventListener("touchstart", handleTouchStart, {
//         passive: false,
//       });
//       imageWrapper.addEventListener("touchmove", handleTouchMove, {
//         passive: false,
//       });
//       imageWrapper.addEventListener("touchend", handleTouchEnd);
//       imageWrapper.addEventListener("dblclick", handleDoubleClick);
//       imageWrapper.addEventListener("wheel", handleWheel, { passive: false });
//     }
//   }

//   function openZoomModal(index) {
//     const modal = document.getElementById("imageZoomModal");
//     const product = window.luxuryProduct;
//     if (!modal || !product || !product.media || !product.media.length) return;

//     currentZoomIndex = index;
//     zoomScale = 1;
//     zoomTranslate = { x: 0, y: 0 };

//     modal.setAttribute("data-single-image", product.media.length <= 1);
//     updateZoomImage();
//     buildZoomThumbnails();
//     modal.classList.add("active");
//     document.body.style.overflow = "hidden";
//   }

//   function closeZoomModal() {
//     const modal = document.getElementById("imageZoomModal");
//     if (modal) {
//       modal.classList.remove("active");
//       document.body.style.overflow = "";
//     }
//     // pause cached modal video
//     if (cachedModalVideo && !cachedModalVideo.paused) {
//       try {
//         cachedModalVideo.pause();
//       } catch (e) {}
//     }
//   }

//   function navigateZoom(direction) {
//     const product = window.luxuryProduct;
//     if (!product || !product.media || !product.media.length) return;
//     currentZoomIndex += direction;
//     if (currentZoomIndex < 0) currentZoomIndex = product.media.length - 1;
//     if (currentZoomIndex >= product.media.length) currentZoomIndex = 0;
//     zoomScale = 1;
//     zoomTranslate = { x: 0, y: 0 };
//     updateZoomImage();
//     updateZoomThumbnails();
//     if (mainSwiper && typeof mainSwiper.slideTo === "function")
//       mainSwiper.slideTo(currentZoomIndex);
//   }

//   function updateZoomImage() {
//     const product = window.luxuryProduct;
//     const wrapper = document.getElementById("zoomImageWrapper");
//     const counter = document.getElementById("zoomCounter");
//     if (!product || !wrapper) return;
//     const media = product.media[currentZoomIndex];
//     wrapper.innerHTML = "";

//     if (!media) return;

//     if (media.type === "image") {
//       const imgEl = document.createElement("img");
//       imgEl.src = media.url;
//       imgEl.alt = media.alt || "";
//       imgEl.className = "lux-zoom-image";
//       imgEl.draggable = false;
//       wrapper.appendChild(imgEl);
//       // pause modal video if any
//       if (cachedModalVideo && !cachedModalVideo.paused) {
//         try {
//           cachedModalVideo.pause();
//         } catch (e) {}
//       }
//     } else if (media.type === "video") {
//       if (!cachedModalVideo) {
//         cachedModalVideo = document.createElement("video");
//         cachedModalVideo.className = "lux-zoom-video";
//         try {
//           cachedModalVideo.crossOrigin = "anonymous";
//         } catch (e) {}
//         cachedModalVideo.controls = true;
//         cachedModalVideo.muted = true;
//         cachedModalVideo.loop = true;
//         cachedModalVideo.playsInline = true;
//         cachedModalVideo.preload = "auto";
//         cachedModalVideo.setAttribute("playsinline", "");
//         cachedModalVideo.setAttribute("webkit-playsinline", "");
//         cachedModalVideo.disablePictureInPicture = true;
//         cachedModalVideo.style.pointerEvents = "auto";

//         // Start hidden; we'll fade-in after decode/frame ready to avoid blurred first-frame
//         cachedModalVideo.style.opacity = "0";
//         cachedModalVideo.style.transition = "opacity 220ms ease";

//         const revealModalVideo = async () => {
//           try {
//             if (typeof cachedModalVideo.decode === "function") {
//               await cachedModalVideo.decode();
//             } else {
//               await new Promise((r) => setTimeout(r, 60));
//             }
//           } catch (err) {
//             // ignore decode errors
//           }

//           // small seek to encourage a clean frame on some browsers
//           try {
//             cachedModalVideo.currentTime = Math.min(
//               0.01,
//               cachedModalVideo.duration || 0.01,
//             );
//           } catch (e) {}

//           try {
//             const p = cachedModalVideo.play && cachedModalVideo.play();
//             if (p && typeof p.then === "function") p.catch(() => {});
//           } catch (e) {}

//           if (
//             typeof cachedModalVideo.requestVideoFrameCallback === "function"
//           ) {
//             try {
//               cachedModalVideo.requestVideoFrameCallback(() => {
//                 cachedModalVideo.style.opacity = "1";
//               });
//             } catch (e) {
//               cachedModalVideo.style.opacity = "1";
//             }
//           } else {
//             setTimeout(() => (cachedModalVideo.style.opacity = "1"), 80);
//           }
//         };

//         once(cachedModalVideo, "loadeddata", function () {
//           revealModalVideo();
//         });
//         once(cachedModalVideo, "loadedmetadata", function () {
//           setTimeout(revealModalVideo, 30);
//         });
//       }

//       // Update sources for modal video — prefer cached blob URLs per <source>
//       (async () => {
//         try {
//           // remove prior sources
//           while (cachedModalVideo.firstChild)
//             cachedModalVideo.removeChild(cachedModalVideo.firstChild);

//           // Collect source candidates. media.sources may exist (Shopify); fall back to media.url
//           const candidates = Array.isArray(media.sources)
//             ? media.sources.map((s) => ({
//                 url: s.url,
//                 type: s.mime_type || s.type,
//               }))
//             : media.url
//               ? [{ url: media.url, type: media.mime_type || "" }]
//               : [];

//           let anySet = false;
//           for (const s of candidates) {
//             if (!s || !s.url) continue;
//             try {
//               // On iOS prefer direct network URL — blob URLs and cached responses
//               // can cause playback issues in some Safari versions.
//               const blobUrl = !isIOS ? await getCachedBlobUrl(s.url) : null;
//               const srcUrl = blobUrl || s.url;
//               const sourceEl = document.createElement("source");
//               sourceEl.src = srcUrl;
//               if (s.type) sourceEl.type = s.type;
//               cachedModalVideo.appendChild(sourceEl);
//               if (blobUrl)
//                 console.debug("lux video: using cached blob for modal", s.url);
//               else cacheVideoResource(s.url);
//               anySet = true;
//             } catch (e) {
//               // fallback: append remote
//               try {
//                 const sourceEl = document.createElement("source");
//                 sourceEl.src = s.url;
//                 if (s.type) sourceEl.type = s.type;
//                 cachedModalVideo.appendChild(sourceEl);
//                 cacheVideoResource(s.url);
//                 anySet = true;
//               } catch (err) {}
//             }
//           }

//           if (anySet) {
//             try {
//               cachedModalVideo.load();
//             } catch (e) {}
//           }
//         } catch (e) {
//           // Last-resort: set src directly
//           try {
//             if (media.url) {
//               cachedModalVideo.src = media.url;
//               try {
//                 cachedModalVideo.load();
//               } catch (e) {}
//               cacheVideoResource(media.url);
//             }
//           } catch (err) {}
//         }
//       })();
//       cachedModalVideo.id = "zoomVideo";
//       // set poster when available so modal shows a preview immediately on mobile
//       try {
//         cachedModalVideo.poster = media.previewUrl || media.preview_image || "";
//       } catch (e) {}
//       // Debug hooks: log play errors and state for easier diagnosis on mobile
//       cachedModalVideo.addEventListener("play", () =>
//         console.debug("lux video: modal play event"),
//       );
//       cachedModalVideo.addEventListener("playing", () =>
//         console.debug("lux video: modal playing"),
//       );
//       cachedModalVideo.addEventListener("pause", () =>
//         console.debug("lux video: modal paused"),
//       );
//       cachedModalVideo.addEventListener("error", (ev) => {
//         console.warn("lux video: modal error event", ev);
//       });
//       wrapper.appendChild(cachedModalVideo);
//       // try to play (may be blocked if browser policies apply)
//       try {
//         cachedModalVideo.play().catch(() => {});
//       } catch (e) {}

//       // Mobile browsers often block autoplay even in modals — ensure the poster/controls are visible
//       // If the video fails to load or remains paused, reveal poster fallback so user can tap Play.
//       const loadTimeout = setTimeout(() => {
//         try {
//           if (cachedModalVideo.readyState < 2 || cachedModalVideo.paused) {
//             // reveal poster/controls
//             cachedModalVideo.style.opacity = "1";
//             // create fallback image if no poster shown by browser
//             try {
//               const poster =
//                 cachedModalVideo.poster ||
//                 media.previewUrl ||
//                 media.preview_image ||
//                 "";
//               if (poster) {
//                 const existingFallback = wrapper.querySelector(
//                   ".lux-modal-poster-fallback",
//                 );
//                 if (!existingFallback) {
//                   const img = document.createElement("img");
//                   img.src = poster;
//                   img.alt = media.alt || "";
//                   img.className = "lux-modal-poster-fallback";
//                   img.style.width = "100%";
//                   img.style.height = "100%";
//                   img.style.objectFit = "contain";
//                   img.style.position = "absolute";
//                   img.style.inset = "0";
//                   // IMPORTANT: don't block pointer events so touch/swipe reach the wrapper
//                   img.style.pointerEvents = "none";
//                   img.style.zIndex = "0";
//                   wrapper.appendChild(img);
//                 }
//                 // allow tapping the wrapper to attempt to play the video (tap-to-play)
//                 try {
//                   const tryPlay = () => {
//                     if (!cachedModalVideo) return;
//                     try {
//                       const p =
//                         cachedModalVideo.play && cachedModalVideo.play();
//                       if (p && typeof p.then === "function") {
//                         p.then(() =>
//                           console.debug("lux video: play promise resolved"),
//                         ).catch((err) => {
//                           console.warn("lux video: play promise rejected", err);
//                           // show controls as a fallback so user can tap
//                           try {
//                             cachedModalVideo.controls = true;
//                           } catch (e) {}
//                           try {
//                             cachedModalVideo.style.opacity = "1";
//                           } catch (e) {}
//                         });
//                       }
//                     } catch (e) {
//                       console.warn("lux video: play call failed", e);
//                     }
//                   };

//                   // Robust tap-to-play that doesn't block swipe/pan gestures.
//                   // Detect short taps (no meaningful movement) and trigger play.
//                   let tapState = {
//                     startX: null,
//                     startY: null,
//                     startT: null,
//                     moved: false,
//                   };
//                   function onTapTouchStart(e) {
//                     if (!e.touches || e.touches.length !== 1) return;
//                     tapState.startX = e.touches[0].clientX;
//                     tapState.startY = e.touches[0].clientY;
//                     tapState.startT = Date.now();
//                     tapState.moved = false;
//                   }
//                   function onTapTouchMove(e) {
//                     if (
//                       !tapState.startX ||
//                       !e.touches ||
//                       e.touches.length !== 1
//                     )
//                       return;
//                     const dx = Math.abs(e.touches[0].clientX - tapState.startX);
//                     const dy = Math.abs(e.touches[0].clientY - tapState.startY);
//                     if (dx > 10 || dy > 10) tapState.moved = true;
//                   }
//                   function onTapTouchEnd(e) {
//                     const dt = Date.now() - (tapState.startT || 0);
//                     // short tap and no movement -> treat as tap
//                     if (!tapState.moved && dt < 300) tryPlay();
//                     tapState.startX = tapState.startY = tapState.startT = null;
//                     tapState.moved = false;
//                   }

//                   // Also keep a click handler for non-touch environments
//                   wrapper.addEventListener("click", tryPlay, { passive: true });
//                   // Touch handlers: start needs passive:false to allow preventing if needed by other logic
//                   wrapper.addEventListener("touchstart", onTapTouchStart, {
//                     passive: false,
//                   });
//                   wrapper.addEventListener("touchmove", onTapTouchMove, {
//                     passive: true,
//                   });
//                   wrapper.addEventListener("touchend", onTapTouchEnd, {
//                     passive: true,
//                   });

//                   // Remove listeners once video has loaded data to avoid lingering handlers
//                   once(cachedModalVideo, "loadeddata", function () {
//                     try {
//                       wrapper.removeEventListener("click", tryPlay);
//                       wrapper.removeEventListener(
//                         "touchstart",
//                         onTapTouchStart,
//                       );
//                       wrapper.removeEventListener("touchmove", onTapTouchMove);
//                       wrapper.removeEventListener("touchend", onTapTouchEnd);
//                     } catch (e) {}
//                   });
//                 } catch (e) {}
//               }
//             } catch (e) {}
//           }
//         } catch (e) {}
//       }, 1000);

//       // clear fallback if load succeeds
//       once(cachedModalVideo, "loadeddata", function () {
//         try {
//           clearTimeout(loadTimeout);
//         } catch (e) {}
//       });
//       // on error show poster fallback immediately
//       cachedModalVideo.addEventListener("error", function () {
//         try {
//           cachedModalVideo.style.opacity = "1";
//           const poster =
//             cachedModalVideo.poster ||
//             media.previewUrl ||
//             media.preview_image ||
//             "";
//           if (poster) {
//             const img = document.createElement("img");
//             img.src = poster;
//             img.alt = media.alt || "";
//             img.className = "lux-modal-poster-fallback";
//             img.style.width = "100%";
//             img.style.height = "100%";
//             img.style.objectFit = "contain";
//             img.style.position = "absolute";
//             img.style.inset = "0";
//             img.style.pointerEvents = "none";
//             img.style.zIndex = "0";
//             wrapper.appendChild(img);
//           }
//         } catch (e) {}
//       });
//     }

//     if (counter) {
//       counter.textContent = currentZoomIndex + 1 + " / " + product.media.length;
//     }
//   }

//   function buildZoomThumbnails() {
//     const product = window.luxuryProduct;
//     const container = document.getElementById("zoomThumbnails");
//     if (!product || !container) return;
//     container.innerHTML = "";
//     product.media.forEach((media, index) => {
//       const thumb = document.createElement("button");
//       thumb.className =
//         "lux-zoom-thumb" + (index === currentZoomIndex ? " active" : "");
//       const src = media.previewUrl || media.url || "";
//       thumb.innerHTML = `<img src="${src}" alt="Thumbnail">`;
//       thumb.addEventListener("click", function () {
//         currentZoomIndex = index;
//         zoomScale = 1;
//         zoomTranslate = { x: 0, y: 0 };
//         updateZoomImage();
//         updateZoomThumbnails();
//         if (mainSwiper && typeof mainSwiper.slideTo === "function")
//           mainSwiper.slideTo(index);
//       });
//       container.appendChild(thumb);
//     });
//     // Make thumbnails horizontally scrollable and swipeable on touch devices
//     try {
//       container.style.overflowX = "auto";
//       container.style.WebkitOverflowScrolling = "touch";
//       container.style.display = "flex";
//       container.style.gap = "8px";
//       container.style.padding = "8px 12px";
//       container.style.touchAction = "pan-x";

//       // Let native horizontal scrolling handle touch swipes for better UX.
//       // The CSS `overflow-x: auto` + `touch-action: pan-x` allows smooth native swiping.
//       let isDown = false;
//       let startX = 0;
//       let startScroll = 0;

//       // Desktop drag-to-scroll support
//       let mouseDown = false;
//       container.addEventListener("mousedown", function (e) {
//         // prevent parent from stealing mouse drag
//         try {
//           e.stopPropagation();
//         } catch (er) {}
//         mouseDown = true;
//         startX = e.pageX;
//         startScroll = container.scrollLeft;
//         container.classList.add("lux-dragging");
//         e.preventDefault();
//       });
//       window.addEventListener("mousemove", function (e) {
//         if (!mouseDown) return;
//         const x = e.pageX;
//         const walk = startX - x;
//         container.scrollLeft = startScroll + walk;
//       });
//       window.addEventListener("mouseup", function () {
//         if (mouseDown) container.classList.remove("lux-dragging");
//         mouseDown = false;
//       });

//       // Pointer events (recommended) - capture pointer to reliably track swipes
//       try {
//         let pointerActive = false;
//         let pointerId = null;
//         container.addEventListener("pointerdown", function (e) {
//           // Only track primary pointers (finger/mouse)
//           if (pointerActive) return;
//           try {
//             e.stopPropagation();
//           } catch (er) {}
//           pointerActive = true;
//           pointerId = e.pointerId;
//           startX = e.clientX;
//           startScroll = container.scrollLeft;
//           container.setPointerCapture && container.setPointerCapture(pointerId);
//         });

//         container.addEventListener("pointermove", function (e) {
//           if (!pointerActive || e.pointerId !== pointerId) return;
//           try {
//             e.stopPropagation();
//           } catch (er) {}
//           const x = e.clientX;
//           const walk = startX - x;
//           if (Math.abs(walk) > 2) e.preventDefault();
//           container.scrollLeft = startScroll + walk;
//         });

//         container.addEventListener("pointerup", function (e) {
//           if (e.pointerId !== pointerId) return;
//           try {
//             e.stopPropagation();
//           } catch (er) {}
//           pointerActive = false;
//           try {
//             container.releasePointerCapture &&
//               container.releasePointerCapture(pointerId);
//           } catch (er) {}
//           pointerId = null;
//         });

//         container.addEventListener("pointercancel", function (e) {
//           if (e.pointerId !== pointerId) return;
//           pointerActive = false;
//           try {
//             container.releasePointerCapture &&
//               container.releasePointerCapture(pointerId);
//           } catch (er) {}
//           pointerId = null;
//         });
//       } catch (er) {
//         // ignore pointer support failures
//       }
//     } catch (e) {
//       // ignore environment where styling or events fail
//     }
//   }

//   function updateZoomThumbnails() {
//     const thumbs = document.querySelectorAll(".lux-zoom-thumb");
//     thumbs.forEach((thumb, idx) =>
//       thumb.classList.toggle("active", idx === currentZoomIndex),
//     );
//   }

//   /* --------------------------------------------------------------------------
//      Zoom interaction handlers (pinch to zoom, pan) — similar to original
//      -------------------------------------------------------------------------- */
//   let startRef = { x: 0, y: 0 };
//   let startTranslateRef = { x: 0, y: 0 };
//   let swipeStartX = null;

//   function handleTouchStart(e) {
//     if (e.touches.length === 2) {
//       isPanning = false;
//       lastTouchDistance = getDistance(e.touches[0], e.touches[1]);
//     } else if (e.touches.length === 1) {
//       swipeStartX = e.touches[0].clientX;
//       startRef = { x: e.touches[0].clientX, y: e.touches[0].clientY };
//       startTranslateRef = { x: zoomTranslate.x, y: zoomTranslate.y };
//       isPanning = zoomScale > 1;
//     }
//   }

//   function handleTouchMove(e) {
//     const wrapper = document.getElementById("zoomImageWrapper");
//     if (!wrapper) return;
//     const zoomImageEl =
//       wrapper.querySelector(".lux-zoom-image") ||
//       wrapper.querySelector(".lux-zoom-video");
//     if (!zoomImageEl) return;

//     if (e.touches.length === 2) {
//       e.preventDefault();
//       const newDist = getDistance(e.touches[0], e.touches[1]);
//       if (lastTouchDistance !== null) {
//         const delta = newDist - lastTouchDistance;
//         // PINCH only applies to images (we keep video scale = 1 for stability)
//         if (zoomImageEl.tagName.toLowerCase() === "img") {
//           zoomScale = Math.min(3, Math.max(1, zoomScale + delta / 200));
//           updateZoomTransform();
//         }
//       }
//       lastTouchDistance = newDist;
//     } else if (e.touches.length === 1 && isPanning) {
//       const img = wrapper.querySelector(".lux-zoom-image");
//       if (!img) return;
//       e.preventDefault();
//       const dx = e.touches[0].clientX - startRef.x;
//       const dy = e.touches[0].clientY - startRef.y;
//       zoomTranslate = {
//         x: startTranslateRef.x + dx,
//         y: startTranslateRef.y + dy,
//       };
//       updateZoomTransform();
//     }
//   }

//   function handleTouchEnd(e) {
//     if (!isPanning && zoomScale === 1 && swipeStartX !== null) {
//       const changed = e.changedTouches && e.changedTouches[0];
//       const endX = changed ? changed.clientX : swipeStartX;
//       const dx = endX - swipeStartX;
//       if (Math.abs(dx) > 60) {
//         navigateZoom(dx < 0 ? 1 : -1);
//       }
//     }
//     if (e.touches && e.touches.length < 2) lastTouchDistance = null;
//     isPanning = false;
//     swipeStartX = null;
//   }

//   function handleDoubleClick() {
//     const wrapper = document.getElementById("zoomImageWrapper");
//     const img = wrapper ? wrapper.querySelector(".lux-zoom-image") : null;
//     if (!img) return;
//     if (zoomScale > 1) {
//       zoomScale = 1;
//       zoomTranslate = { x: 0, y: 0 };
//     } else {
//       zoomScale = 2;
//     }
//     updateZoomTransform();
//   }

//   function handleWheel(e) {
//     const wrapper = document.getElementById("zoomImageWrapper");
//     const targetIsVideo =
//       e.target &&
//       (e.target.tagName === "VIDEO" ||
//         (e.target.closest && e.target.closest(".lux-zoom-video")));
//     if (targetIsVideo) return;
//     e.preventDefault();
//     const delta = -e.deltaY;
//     zoomScale = Math.min(3, Math.max(1, zoomScale + delta / 400));
//     updateZoomTransform();
//   }

//   function updateZoomTransform() {
//     const img = document.querySelector(".lux-zoom-image");
//     if (!img) return;
//     img.style.transform =
//       "translate(" +
//       zoomTranslate.x +
//       "px, " +
//       zoomTranslate.y +
//       "px) scale(" +
//       zoomScale +
//       ")";
//     img.style.willChange = "transform";
//   }

//   function getDistance(t1, t2) {
//     const dx = t1.clientX - t2.clientX;
//     const dy = t1.clientY - t2.clientY;
//     return Math.sqrt(dx * dx + dy * dy);
//   }

//   /* --------------------------------------------------------------------------
//      Per-slide video handling: create stable video elements for slide usage,
//      and auto-play/pause videos only when their slide is visible (IntersectionObserver
//      + Swiper slideChange sync)
//      -------------------------------------------------------------------------- */
//   // Create video element with optimal attributes for inline autoplay
//   function createSlideVideo(src, poster) {
//     const video = document.createElement("video");
//     video.className = "lux-slide-video";
//     // Prefer a cached blob URL when available, otherwise use remote src and cache in background
//     (async () => {
//       try {
//         const blobUrl = await getCachedBlobUrl(src);
//         if (blobUrl) {
//           video.src = blobUrl;
//         } else {
//           video.src = src;
//           // Start caching in background (don't await)
//           cacheVideoResource(src);
//         }
//       } catch (e) {
//         video.src = src;
//         cacheVideoResource(src);
//       }
//     })();
//     // allow cross-origin decoding if server supports CORS
//     try {
//       video.crossOrigin = "anonymous";
//     } catch (e) {}
//     video.muted = true;
//     video.loop = true;
//     video.preload = "auto";
//     video.playsInline = true;
//     video.setAttribute("playsinline", "");
//     video.setAttribute("webkit-playsinline", "");
//     // Use poster to show preview before decoded frame
//     if (poster) video.poster = poster;
//     video.style.objectFit = "cover";
//     // Smooth fade-in when first decoded to avoid blurred first-frame
//     video.style.opacity = "0";
//     video.style.transition = "opacity 220ms ease";

//     const reveal = async () => {
//       try {
//         if (typeof video.decode === "function") {
//           await video.decode();
//         } else {
//           // fallback small delay to allow browser to decode
//           await new Promise((r) => setTimeout(r, 60));
//         }
//       } catch (e) {
//         // ignore decode errors (CORS/codecs)
//       } finally {
//         video.style.opacity = "1";
//         try {
//           video.play().catch(() => {});
//         } catch (e) {}
//       }
//     };

//     // Attempt reveal once we have some data
//     video.addEventListener("loadeddata", function onld() {
//       video.removeEventListener("loadeddata", onld);
//       reveal();
//     });
//     // Safety: also trigger after metadata if loadeddata doesn't fire
//     video.addEventListener("loadedmetadata", function onmeta() {
//       video.removeEventListener("loadedmetadata", onmeta);
//       setTimeout(reveal, 30);
//     });

//     return video;
//   }

//   // Reveal logic for any video element (existing or created)
//   function revealVideoElement(video) {
//     if (!video) return;
//     // ensure style and transition exist
//     if (!video.style) video.style = {};
//     video.style.transition = video.style.transition || "opacity 220ms ease";
//     // hide initially if not already hidden
//     if (!video.style.opacity) video.style.opacity = "0";

//     const doReveal = async () => {
//       try {
//         if (typeof video.decode === "function") await video.decode();
//         else await new Promise((r) => setTimeout(r, 60));
//       } catch (e) {
//         // ignore
//       }

//       try {
//         const p = video.play && video.play();
//         if (p && typeof p.then === "function") p.catch(() => {});
//       } catch (e) {}

//       if (typeof video.requestVideoFrameCallback === "function") {
//         try {
//           video.requestVideoFrameCallback(() => {
//             video.style.opacity = "1";
//           });
//         } catch (e) {
//           video.style.opacity = "1";
//         }
//       } else {
//         setTimeout(() => (video.style.opacity = "1"), 80);
//       }
//     };

//     // If already has enough data, reveal now
//     if (video.readyState >= 2) {
//       doReveal();
//     } else {
//       once(video, "loadeddata", doReveal);
//       once(video, "loadedmetadata", () => setTimeout(doReveal, 30));
//     }
//   }

//   // Observe slide visibility and play/pause accordingly
//   function syncSlideVideoPlayback(activeIndex) {
//     // Pause videos on non-active slides, play on active
//     const slides = document.querySelectorAll(
//       "#productMainSwiper .swiper-slide, .lux-slide",
//     );
//     slides.forEach((slide, idx) => {
//       const video = slide.querySelector("video");
//       if (!video) return;
//       if (idx === activeIndex) {
//         // attempt play (muted -> autoplay allowed)
//         try {
//           video.play().catch(() => {});
//         } catch (e) {}
//       } else {
//         try {
//           video.pause();
//           // keep currentTime at small positive to keep decode cached frame
//         } catch (e) {}
//       }
//     });
//   }

//   /* --------------------------------------------------------------------------
//      Add to Cart — AJAX behavior unchanged but made a bit safer
//      -------------------------------------------------------------------------- */
//   function initAddToCart() {
//     const form = document.querySelector("[data-product-form]");
//     if (!form) return;

//     form.addEventListener("submit", async function (e) {
//       const submitBtn = e.submitter;
//       const isBuyNow = submitBtn && submitBtn.hasAttribute("data-buy-now-btn");
//       e.preventDefault();
//       const variantId = form.querySelector("[data-variant-id]").value;
//       try {
//         await fetch("/cart/add.js", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify({
//             items: [{ id: parseInt(variantId, 10), quantity: 1 }],
//           }),
//         });

//         if (isBuyNow) {
//           window.location.href = "/checkout";
//           return;
//         }
//         openCartDrawer();
//         updateCartCount();
//       } catch (err) {
//         console.error("Cart error:", err);
//         alert("Failed to add to cart");
//       }
//     });
//   }

//   async function updateCartCount() {
//     try {
//       const response = await fetch("/cart.js");
//       const cart = await response.json();
//       const countElements = document.querySelectorAll("[data-cart-count]");
//       countElements.forEach((el) => {
//         el.textContent = cart.item_count;
//         el.style.display = cart.item_count > 0 ? "" : "none";
//       });
//     } catch (error) {
//       console.error("Error updating cart count:", error);
//     }
//   }

//   /* --------------------------------------------------------------------------
//      Cart Drawer: render & bind actions (kept from original but robustified)
//      -------------------------------------------------------------------------- */
//   function openCartDrawer() {
//     const drawer = document.getElementById("cart-drawer-luxury");
//     if (drawer) {
//       drawer.classList.add("is-active");
//       document.body.style.overflow = "hidden";
//       renderCartItems();
//     }
//   }

//   function closeCartDrawer() {
//     const drawer = document.getElementById("cart-drawer-luxury");
//     if (drawer) {
//       drawer.classList.remove("is-active");
//       document.body.style.overflow = "";
//     }
//   }

//   async function renderCartItems() {
//     const container = document.querySelector("[data-cart-items-luxury]");
//     const emptyState = document.querySelector("[data-cart-empty-luxury]");
//     const filledState = document.querySelector("[data-cart-filled-luxury]");
//     const totalEl = document.querySelector("[data-cart-total-luxury]");
//     if (!container) return;
//     try {
//       const response = await fetch("/cart.js");
//       const cart = await response.json();
//       if (cart.item_count === 0) {
//         if (emptyState) emptyState.style.display = "flex";
//         if (filledState) filledState.style.display = "none";
//         container.innerHTML = "";
//         return;
//       }
//       if (emptyState) emptyState.style.display = "none";
//       if (filledState) filledState.style.display = "flex";

//       container.innerHTML = cart.items
//         .map((item, index) => {
//           return `
//           <div class="cart-item-luxury" data-line-item="${index + 1}">
//             <div class="cart-item-luxury__image">
//               ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ""}
//             </div>
//             <div class="cart-item-luxury__details">
//               <h3 class="cart-item-luxury__title">${item.product_title}</h3>
//               <p class="cart-item-luxury__variant">${item.variant_title || ""}</p>
//               <div class="cart-item-luxury__price-row">
//                 <p class="cart-item-luxury__price">${formatMoney(item.final_line_price)}</p>
//                 ${
//                   item.quantity > 1
//                     ? `<p class="cart-item-luxury__each">${formatMoney(item.final_price)} each</p>`
//                     : ""
//                 }
//               </div>
//             </div>
//             <div class="cart-item-luxury__actions">
//               <div class="cart-item-luxury__quantity">
//                 <button type="button" class="cart-qty-btn" data-action="decrease" data-line="${
//                   index + 1
//                 }" ${item.quantity <= 1 ? "disabled" : ""}>
//                   - 
//                 </button>
//                 <span class="cart-qty-value">${item.quantity}</span>
//                 <button type="button" class="cart-qty-btn" data-action="increase" data-line="${
//                   index + 1
//                 }">+</button>
//               </div>
//               <button type="button" class="cart-remove-btn" data-action="remove" data-line="${
//                 index + 1
//               }">Remove</button>
//             </div>
//           </div>`;
//         })
//         .join("");

//       if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
//       bindCartItemActions();
//     } catch (error) {
//       console.error("Error rendering cart:", error);
//     }
//   }

//   function bindCartItemActions() {
//     const buttons = document.querySelectorAll("[data-action]");
//     // remove duplicates by cloning
//     buttons.forEach((btn) => {
//       const clone = btn.cloneNode(true);
//       btn.parentNode.replaceChild(clone, btn);
//     });

//     const freshButtons = document.querySelectorAll("[data-action]");
//     freshButtons.forEach((btn) => {
//       btn.addEventListener("click", async function () {
//         const action = this.dataset.action;
//         const line = parseInt(this.dataset.line, 10);
//         let updates = {};
//         const itemEl = this.closest(".cart-item-luxury");
//         const qtyEl = itemEl ? itemEl.querySelector(".cart-qty-value") : null;
//         const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

//         if (action === "remove") updates = { line: line, quantity: 0 };
//         else if (action === "decrease")
//           updates = { line: line, quantity: Math.max(0, currentQty - 1) };
//         else if (action === "increase")
//           updates = { line: line, quantity: currentQty + 1 };

//         try {
//           await fetch("/cart/change.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(updates),
//           });
//           renderCartItems();
//           updateCartCount();
//         } catch (error) {
//           console.error("Error updating cart:", error);
//         }
//       });
//     });
//   }

//   function formatMoney(cents) {
//     const amount = (cents / 100).toFixed(2);
//     const currency =
//       (window.Shopify &&
//         window.Shopify.currency &&
//         window.Shopify.currency.active) ||
//       "INR";
//     if (currency === "INR") return "₹" + amount;
//     if (currency === "USD") return "$" + amount;
//     if (currency === "EUR") return "€" + amount;
//     if (currency === "GBP") return "£" + amount;
//     return currency + " " + amount;
//   }

//   /* --------------------------------------------------------------------------
//      Utility: when product area mounts, ensure slide video elements are created
//      - If your Liquid outputs <div class="lux-slide" data-media-type="video" data-media-src="...">,
//        this will convert those placeholders into proper <video> elements, with posters where provided.
//      -------------------------------------------------------------------------- */
//   function ensureSlideVideos() {
//     const videoPlaceholders = document.querySelectorAll(
//       ".lux-slide[data-media-type='video']",
//     );
//     videoPlaceholders.forEach((ph) => {
//       if (ph.querySelector("video")) return;
//       const src = ph.dataset.mediaSrc;
//       const poster = ph.dataset.mediaPoster || ph.dataset.preview || "";
//       if (!src) return;
//       const v = createSlideVideo(src, poster);
//       // Ensure we don't auto-play all — IntersectionObserver handles playback.
//       ph.appendChild(v);
//       // Reveal created element (in case it was hidden by CSS)
//       revealVideoElement(v);
//     });

//     // Also handle existing video elements (theme may already output <video> tags)
//     const existingVideos = document.querySelectorAll(
//       ".lux-slide video, video.lux-slide-video",
//     );
//     existingVideos.forEach((vid) => {
//       // ensure it has the class for consistent styling
//       if (!vid.classList.contains("lux-slide-video"))
//         vid.classList.add("lux-slide-video");
//       // Try to replace src with cached blob URL if available, then reveal
//       (async () => {
//         try {
//           const src = vid.currentSrc || vid.src;
//           // prefer replacing <source> children if present (keeps source ordering)
//           const sources = Array.from(vid.querySelectorAll("source"));
//           if (sources.length) {
//             let replaced = false;
//             for (const s of sources) {
//               const sUrl = s.getAttribute("src");
//               if (!sUrl) continue;
//               const blobUrl = await getCachedBlobUrl(sUrl);
//               if (blobUrl) {
//                 s.setAttribute("src", blobUrl);
//                 replaced = true;
//               } else {
//                 // start caching in background
//                 cacheVideoResource(sUrl);
//               }
//             }
//             if (replaced) {
//               try {
//                 vid.load();
//               } catch (e) {}
//             }
//           } else if (src) {
//             const blobUrl = await getCachedBlobUrl(src);
//             if (blobUrl) {
//               const ct = vid.currentTime || 0;
//               vid.src = blobUrl;
//               try {
//                 vid.currentTime = ct;
//               } catch (e) {}
//             } else {
//               if (src) cacheVideoResource(src);
//             }
//           }
//         } catch (e) {
//           // ignore
//         } finally {
//           revealVideoElement(vid);
//         }
//       })();
//     });

//     // Use IntersectionObserver to auto-play visible videos (for non-Swiper fallback)
//     try {
//       const io = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             const vid = entry.target.querySelector("video");
//             if (!vid) return;
//             if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
//               try {
//                 vid.play().catch(() => {});
//               } catch (e) {}
//             } else {
//               try {
//                 vid.pause();
//               } catch (e) {}
//             }
//           });
//         },
//         { threshold: [0.5, 0.75] },
//       );

//       document
//         .querySelectorAll(".lux-slide")
//         .forEach((slide) => io.observe(slide));
//     } catch (e) {
//       // IntersectionObserver not supported — don't break functionality
//     }
//   }

//   // Call ensureSlideVideos shortly after DOM ready so Liquid placeholders are present
//   raf(() => raf(ensureSlideVideos));

//   /* --------------------------------------------------------------------------
//      When a slide is visible in Swiper, play/pause is maintained via syncSlideVideoPlayback
//      But for non-swiper flows we still ensure visibility control above.
//      -------------------------------------------------------------------------- */

//   // Initialize once
//   init();

//   // Expose helper to open zoom modal programmatically
//   window.openZoomModal = openZoomModal;

//   // Sync video playback for Swiper when slides change externally (public)
//   window.syncSlideVideoPlayback = syncSlideVideoPlayback;
// })();




/* ==========================================================================
   LUXURY PRODUCT PAGE JAVASCRIPT (Optimized Video Playback)
   Replaces existing IIFE. Keeps same public functions: openCartDrawer, renderCartItems, etc.
   ========================================================================== */
(function () {
  "use strict";

  // Quick CSS tweaks to help video rendering (will-create compositing layer)
  const style = document.createElement("style");
  style.innerHTML = `
    .lux-slide-video,
    .lux-zoom-video {
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      transform: translateZ(0);
      will-change: transform, opacity;
      object-fit: cover;
      width: 100%;
      height: 100%;
      display: block;
      max-height: 100%;
      opacity: 1;
    }
    .lux-zoom-video, .lux-slide-video { opacity: 0; }
    .lux-zoom-image {
      will-change: transform;
    }
  `;
  document.head.appendChild(style);

  // Helpers
  const raf = (fn) => requestAnimationFrame(fn);
  const once = (el, evt, cb) => el.addEventListener(evt, cb, { once: true });

  // Video caching helpers: Cache Storage + blob URL reuse
  const videoCacheName = "luxury-video-cache-v1";
  const blobUrlMap = new Map();

  async function cacheVideoResource(url) {
    if (!url || typeof url !== "string") return;
    // skip HLS playlists (.m3u8)
    if (isHLSUrl(url)) {
      console.debug("lux video: skipping cache for HLS URL", url);
      return;
    }
    if (!("caches" in window)) return;
    try {
      const cache = await caches.open(videoCacheName);
      const matched = await cache.match(url);
      if (matched) return; // already cached
      const resp = await fetch(url, { mode: "cors" });
      if (!resp || !resp.ok) return;
      await cache.put(url, resp.clone());
    } catch (err) {
      // Ignore cache failures (private mode, CORS, etc.)
      console.warn("Video cache failed for", url, err);
    }
  }

  async function getCachedBlobUrl(url) {
    if (!url || typeof url !== "string") return null;
    // never return blob URL for HLS playlists
    if (isHLSUrl(url)) return null;
    if (blobUrlMap.has(url)) return blobUrlMap.get(url);
    if (!("caches" in window)) return null;
    try {
      const cache = await caches.open(videoCacheName);
      const matched = await cache.match(url);
      if (!matched) return null;
      const blob = await matched.blob();
      const blobUrl = URL.createObjectURL(blob);
      blobUrlMap.set(url, blobUrl);
      return blobUrl;
    } catch (err) {
      console.warn("getCachedBlobUrl error", err);
      return null;
    }
  }

  // Cached modal video to avoid decoder re-creation
  let cachedModalVideo = null;

  // Swiper reference (if used)
  let mainSwiper = null;
  // Detect iOS (including iPad with touch) — iOS Safari has known issues with blob URL
  const isIOS = (() => {
    try {
      return (
        /iP(ad|hone|od)/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    } catch (e) {
      return false;
    }
  })();

  // HLS detection: don't cache or convert m3u8 playlists to blob URLs
  function isHLSUrl(url) {
    try {
      if (!url || typeof url !== "string") return false;
      return url.indexOf(".m3u8") !== -1 || /(^|\/)hls(\/|$)/i.test(url);
    } catch (e) {
      return false;
    }
  }

  // Tracks product object expected on window.luxuryProduct: { media: [{type:'image'|'video', url, previewUrl, alt}, ...], ... }
  function init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootstrap);
    } else {
      bootstrap();
    }
  }

  function bootstrap() {
    initSwiper();
    initThumbnails();
    initVariants();
    initTabs();
    initSizeGuide();
    initZoomModal();
    initAddToCart();
    // Warm cache: attempt to cache the first product video (LCP) in background
    try {
      const product = window.luxuryProduct;
      if (product && Array.isArray(product.media)) {
        const firstVideo = product.media.find((m) => m.type === "video");
        if (firstVideo && firstVideo.url) {
          // cache the primary URL and any additional sources if present
          cacheVideoResource(firstVideo.url);
          if (firstVideo.sources && Array.isArray(firstVideo.sources)) {
            firstVideo.sources.forEach((s) => cacheVideoResource(s.url));
          }
        }
      }
    } catch (e) {
      // ignore
    }
    // Expose useful methods for other theme code
    window.renderCartItems = renderCartItems;
    window.openCartDrawer = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
    window.luxuryProduct = window.luxuryProduct || window.luxuryProduct;
  }

  /* --------------------------------------------------------------------------
     Swiper-like minimal integration (keeps behavior from your original code)
     - If you use Swiper library, this will integrate with it; otherwise
       it provides graceful behavior when Swiper is absent.
     -------------------------------------------------------------------------- */
  function initSwiper() {
    const swiperEl = document.getElementById("productMainSwiper");
    if (!swiperEl) return;

    // Always allow an image click/tap to open the full-screen zoom viewer.
    // Swiper sets allowClick=false after a drag, so a swipe will not accidentally
    // open the modal.
    if (swiperEl.dataset.luxZoomBound !== "true") {
      swiperEl.dataset.luxZoomBound = "true";

      swiperEl.addEventListener("click", function (e) {
        const image =
          e.target && e.target.closest
            ? e.target.closest(".lux-slide-image")
            : null;

        if (!image) return;
        if (mainSwiper && mainSwiper.allowClick === false) return;

        const slide = image.closest(".swiper-slide");
        const slides = Array.from(
          swiperEl.querySelectorAll(".swiper-slide"),
        );
        const index = Math.max(0, slides.indexOf(slide));

        openZoomModal(index);
      });

      const zoomTrigger = document.querySelector("[data-lux-open-zoom]");
      if (zoomTrigger) {
        zoomTrigger.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          const index =
            mainSwiper && Number.isInteger(mainSwiper.realIndex)
              ? mainSwiper.realIndex
              : mainSwiper && Number.isInteger(mainSwiper.activeIndex)
                ? mainSwiper.activeIndex
                : 0;

          openZoomModal(index);
        });
      }
    }

    // If Swiper exists, initialize with observers enabled for responsive media.
    if (typeof Swiper !== "undefined") {
      raf(() =>
        raf(() => {
          try {
            mainSwiper = new Swiper("#productMainSwiper", {
              slidesPerView: 1,
              spaceBetween: 0,
              speed: 300,
              allowTouchMove: true,
              centeredSlides: false,
              loop: false,
              watchOverflow: true,
              observer: true,
              observeParents: true,
              resizeObserver: true,
              preloadImages: false,
              lazy: false,
              on: {
                init() {
                  this.update();
                },
                slideChange() {
                  syncSlideVideoPlayback(this.activeIndex);
                  updateThumbnails(this.activeIndex);
                },
              },
            });

            // Ensure video state matches initial slide.
            syncSlideVideoPlayback(mainSwiper.activeIndex || 0);
          } catch (e) {
            console.warn("Swiper init failed:", e);
          }
        }),
      );
    }
  }

  /* --------------------------------------------------------------------------
     Thumbnails (same behavior, update active class and optionally open zoom on mobile)
     -------------------------------------------------------------------------- */
  function initThumbnails() {
    const thumbnails = document.querySelectorAll("[data-thumbnail-index]");
    thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", function () {
        const index = parseInt(this.dataset.thumbnailIndex);
        if (mainSwiper && typeof mainSwiper.slideTo === "function") {
          mainSwiper.slideTo(index);
        } else {
          updateThumbnails(index);
        }
        if (window.innerWidth < 768) openZoomModal(index);
      });
    });
  }

  function updateThumbnails(activeIndex) {
    const thumbnails = document.querySelectorAll("[data-thumbnail-index]");
    thumbnails.forEach((thumb, idx) =>
      thumb.classList.toggle("active", idx === activeIndex),
    );
  }

  /* --------------------------------------------------------------------------
     Variant selection (unchanged logic but safer DOM queries)
     -------------------------------------------------------------------------- */
  function initVariants() {
    const variantButtons = document.querySelectorAll("[data-variant-btn]");
    const variantIdInput = document.querySelector("[data-variant-id]");
    const priceElement = document.querySelector("[data-product-price]");

    variantButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const variantId = this.dataset.variantId;
        const variantPrice = this.dataset.variantPrice;
        const isAvailable = this.dataset.variantAvailable === "true";

        variantButtons.forEach((btn) => {
          btn.classList.remove("selected");
          const glow = btn.querySelector(".lux-variant-glow");
          if (glow) glow.remove();
        });

        this.classList.add("selected");
        const glow = document.createElement("span");
        glow.className = "lux-variant-glow";
        this.appendChild(glow);

        if (variantIdInput) variantIdInput.value = variantId;
        if (priceElement) priceElement.textContent = variantPrice;

        updateActionButton(isAvailable);

        // update URL param (no reload)
        const url = new URL(window.location);
        url.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", url);
      });
    });
    // Evaluate availability on init (if there are no sizes, disable action buttons)
    evaluateVariantAvailability();
  }

  function evaluateVariantAvailability() {
    const variantButtons = Array.from(document.querySelectorAll("[data-variant-btn]"));
    // If no variant buttons exist at all, treat as unavailable
    if (!variantButtons.length) {
      updateActionButton(false);
      return;
    }

    // If a variant is already selected, use its availability
    const selected = document.querySelector("[data-variant-btn].selected");
    if (selected) {
      const selAvailable = selected.dataset.variantAvailable === "true" && !selected.classList.contains("unavailable");
      updateActionButton(!!selAvailable);
      return;
    }

    // Otherwise, if any variant is available, enable buttons (choose first available), else disable
    const anyAvailable = variantButtons.some((btn) => btn.dataset.variantAvailable === "true" && !btn.classList.contains("unavailable"));
    updateActionButton(!!anyAvailable);
  }

  function updateActionButton(isAvailable) {
    const addToCartBtn = document.querySelector("[data-add-to-cart]");
    const buyNowBtn = document.querySelector("[data-buy-now-btn]");

    const setDisabled = (el, disabled) => {
      if (!el) return;
      el.disabled = !!disabled;
      if (disabled) {
        el.setAttribute("aria-disabled", "true");
        el.classList.add("disabled");
      } else {
        el.removeAttribute("aria-disabled");
        el.classList.remove("disabled");
      }
    };

    setDisabled(addToCartBtn, !isAvailable);
    setDisabled(buyNowBtn, !isAvailable);
  }

  /* --------------------------------------------------------------------------
     Tabs
     -------------------------------------------------------------------------- */
  function initTabs() {
    const tabButtons = document.querySelectorAll("[data-tab]");
    const tabPanels = document.querySelectorAll("[data-tab-panel]");

    tabButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const tabId = this.dataset.tab;
        tabButtons.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");
        tabPanels.forEach((panel) =>
          panel.classList.toggle("active", panel.dataset.tabPanel === tabId),
        );
      });
    });
  }

  /* --------------------------------------------------------------------------
     Size Guide unit toggle (unchanged core)
     -------------------------------------------------------------------------- */
function initSizeGuide() {
  const unitToggle = document.querySelector("[data-unit-toggle]");
  if (!unitToggle) return;

  let currentUnit = "cm";
  const parent = unitToggle.parentElement;

  unitToggle.addEventListener("click", function () {
    currentUnit = currentUnit === "cm" ? "in" : "cm";

    const isInch = currentUnit === "in";
    this.classList.toggle("inch", isInch);

    // reset labels
    parent.querySelectorAll(".lux-unit-label").forEach(label => {
      label.classList.remove("active");
    });

    // 🔥 INVERTED LOGIC
    const activeUnit = currentUnit === "cm" ? "in" : "cm";
    parent.querySelector(`[data-unit="${activeUnit}"]`)?.classList.add("active");

    updateMeasurements(currentUnit);
  });
}
  function updateMeasurements(unit) {
    const cells = document.querySelectorAll("[data-cm]");
    cells.forEach((cell) => {
      const cmValue = parseFloat(cell.dataset.cm);
      if (isNaN(cmValue)) return;
      if (unit === "in") {
        const inValue = (cmValue / 2.54).toFixed(1);
        cell.textContent = inValue + "in";
      } else {
        cell.textContent = cmValue.toFixed(1) + "cm";
      }
    });
  }

  /* --------------------------------------------------------------------------
     Image / Video Zoom Modal
     - Reuses one cached modal video element to avoid repeated decoder allocations
     - When a video slide is active in the product area, we attempt to play it muted/inline
     -------------------------------------------------------------------------- */
  const MIN_ZOOM = 1;
  const MAX_ZOOM = 4;
  const DOUBLE_TAP_ZOOM = 2.5;

  let currentZoomIndex = 0;
  let zoomScale = MIN_ZOOM;
  let zoomTranslate = { x: 0, y: 0 };
  let isPanning = false;
  let isZoomGestureActive = false;
  let lastTouchDistance = null;
  let gestureWasPinch = false;
  let gestureMoved = false;
  let lastTap = { time: 0, x: 0, y: 0 };

  function initZoomModal() {
    const modal = document.getElementById("imageZoomModal");
    if (!modal) return;

    const overlay = modal.querySelector(".lux-zoom-overlay");
    const closeBtn = modal.querySelector(".lux-zoom-close");
    const prevBtn = modal.querySelector(".lux-zoom-prev");
    const nextBtn = modal.querySelector(".lux-zoom-next");
    const imageWrapper = document.getElementById("zoomImageWrapper");

    // Custom pinch/pan handling needs browser gestures disabled only inside
    // the zoom surface. The rest of the page keeps normal touch scrolling.
    if (imageWrapper) {
      imageWrapper.style.touchAction = "none";
      imageWrapper.style.overscrollBehavior = "contain";
    }

    overlay && overlay.addEventListener("click", closeZoomModal);
    closeBtn && closeBtn.addEventListener("click", closeZoomModal);

    prevBtn &&
      prevBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        navigateZoom(-1);
      });

    nextBtn &&
      nextBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        navigateZoom(1);
      });

    document.addEventListener("keydown", function (e) {
      if (!modal.classList.contains("active")) return;
      if (e.key === "Escape") closeZoomModal();
      if (e.key === "ArrowLeft" && zoomScale === MIN_ZOOM) navigateZoom(-1);
      if (e.key === "ArrowRight" && zoomScale === MIN_ZOOM) navigateZoom(1);
    });

    if (imageWrapper) {
      imageWrapper.addEventListener("touchstart", handleTouchStart, {
        passive: false,
      });
      imageWrapper.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
      imageWrapper.addEventListener("touchend", handleTouchEnd, {
        passive: false,
      });
      imageWrapper.addEventListener("touchcancel", handleTouchEnd, {
        passive: false,
      });
      imageWrapper.addEventListener("dblclick", handleDoubleClick);
      imageWrapper.addEventListener("wheel", handleWheel, { passive: false });
    }

    window.addEventListener("resize", function () {
      if (!modal.classList.contains("active")) return;
      clampZoomTranslate();
      updateZoomTransform();
    });
  }

  function openZoomModal(index) {
    const modal = document.getElementById("imageZoomModal");
    const product = window.luxuryProduct;
    if (!modal || !product || !product.media || !product.media.length) return;

    currentZoomIndex = Math.min(
      product.media.length - 1,
      Math.max(0, Number(index) || 0),
    );
    resetZoom(false);

    modal.setAttribute("data-single-image", product.media.length <= 1);
    modal.setAttribute("aria-hidden", "false");
    updateZoomImage();
    buildZoomThumbnails();
    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    const closeBtn = modal.querySelector(".lux-zoom-close");
    closeBtn && closeBtn.focus({ preventScroll: true });
  }

  function closeZoomModal() {
    const modal = document.getElementById("imageZoomModal");
    if (modal) {
      modal.classList.remove("active", "is-zoomed");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    resetZoom(false);

    // Pause cached modal video.
    if (cachedModalVideo && !cachedModalVideo.paused) {
      try {
        cachedModalVideo.pause();
      } catch (e) {}
    }
  }

  function navigateZoom(direction) {
    const product = window.luxuryProduct;
    if (!product || !product.media || !product.media.length) return;

    // While zoomed, one-finger dragging pans the image instead of changing media.
    if (zoomScale > MIN_ZOOM + 0.01) return;

    currentZoomIndex += direction;
    if (currentZoomIndex < 0) currentZoomIndex = product.media.length - 1;
    if (currentZoomIndex >= product.media.length) currentZoomIndex = 0;

    resetZoom(false);
    updateZoomImage();
    updateZoomThumbnails();

    if (mainSwiper && typeof mainSwiper.slideTo === "function") {
      mainSwiper.slideTo(currentZoomIndex);
    }
  }

  function updateZoomImage() {
    const product = window.luxuryProduct;
    const wrapper = document.getElementById("zoomImageWrapper");
    const counter = document.getElementById("zoomCounter");
    if (!product || !wrapper) return;
    const media = product.media[currentZoomIndex];
    wrapper.innerHTML = "";

    if (!media) return;

    if (media.type === "image") {
      const imgEl = document.createElement("img");
      imgEl.src = media.url;
      imgEl.alt = media.alt || "";
      imgEl.className = "lux-zoom-image";
      imgEl.draggable = false;
      wrapper.appendChild(imgEl);
      // pause modal video if any
      if (cachedModalVideo && !cachedModalVideo.paused) {
        try {
          cachedModalVideo.pause();
        } catch (e) {}
      }
    } else if (media.type === "video") {
      if (!cachedModalVideo) {
        cachedModalVideo = document.createElement("video");
        cachedModalVideo.className = "lux-zoom-video";
        try {
          cachedModalVideo.crossOrigin = "anonymous";
        } catch (e) {}
        cachedModalVideo.controls = true;
        cachedModalVideo.muted = true;
        cachedModalVideo.loop = true;
        cachedModalVideo.playsInline = true;
        cachedModalVideo.preload = "auto";
        cachedModalVideo.setAttribute("playsinline", "");
        cachedModalVideo.setAttribute("webkit-playsinline", "");
        cachedModalVideo.disablePictureInPicture = true;
        cachedModalVideo.style.pointerEvents = "auto";

        // Start hidden; we'll fade-in after decode/frame ready to avoid blurred first-frame
        cachedModalVideo.style.opacity = "0";
        cachedModalVideo.style.transition = "opacity 220ms ease";

        const revealModalVideo = async () => {
          try {
            if (typeof cachedModalVideo.decode === "function") {
              await cachedModalVideo.decode();
            } else {
              await new Promise((r) => setTimeout(r, 60));
            }
          } catch (err) {
            // ignore decode errors
          }

          // small seek to encourage a clean frame on some browsers
          try {
            cachedModalVideo.currentTime = Math.min(
              0.01,
              cachedModalVideo.duration || 0.01,
            );
          } catch (e) {}

          try {
            const p = cachedModalVideo.play && cachedModalVideo.play();
            if (p && typeof p.then === "function") p.catch(() => {});
          } catch (e) {}

          if (
            typeof cachedModalVideo.requestVideoFrameCallback === "function"
          ) {
            try {
              cachedModalVideo.requestVideoFrameCallback(() => {
                cachedModalVideo.style.opacity = "1";
              });
            } catch (e) {
              cachedModalVideo.style.opacity = "1";
            }
          } else {
            setTimeout(() => (cachedModalVideo.style.opacity = "1"), 80);
          }
        };

        once(cachedModalVideo, "loadeddata", function () {
          revealModalVideo();
        });
        once(cachedModalVideo, "loadedmetadata", function () {
          setTimeout(revealModalVideo, 30);
        });
      }

      // Update sources for modal video — prefer cached blob URLs per <source>
      (async () => {
        try {
          // remove prior sources
          while (cachedModalVideo.firstChild)
            cachedModalVideo.removeChild(cachedModalVideo.firstChild);

          // Collect source candidates. media.sources may exist (Shopify); fall back to media.url
          const candidates = Array.isArray(media.sources)
            ? media.sources.map((s) => ({
                url: s.url,
                type: s.mime_type || s.type,
              }))
            : media.url
              ? [{ url: media.url, type: media.mime_type || "" }]
              : [];

          let anySet = false;
          for (const s of candidates) {
            if (!s || !s.url) continue;
            try {
              // On iOS prefer direct network URL — blob URLs and cached responses
              // can cause playback issues in some Safari versions.
              const blobUrl = !isIOS ? await getCachedBlobUrl(s.url) : null;
              const srcUrl = blobUrl || s.url;
              const sourceEl = document.createElement("source");
              sourceEl.src = srcUrl;
              if (s.type) sourceEl.type = s.type;
              cachedModalVideo.appendChild(sourceEl);
              if (blobUrl)
                console.debug("lux video: using cached blob for modal", s.url);
              else cacheVideoResource(s.url);
              anySet = true;
            } catch (e) {
              // fallback: append remote
              try {
                const sourceEl = document.createElement("source");
                sourceEl.src = s.url;
                if (s.type) sourceEl.type = s.type;
                cachedModalVideo.appendChild(sourceEl);
                cacheVideoResource(s.url);
                anySet = true;
              } catch (err) {}
            }
          }

          if (anySet) {
            try {
              cachedModalVideo.load();
            } catch (e) {}
          }
        } catch (e) {
          // Last-resort: set src directly
          try {
            if (media.url) {
              cachedModalVideo.src = media.url;
              try {
                cachedModalVideo.load();
              } catch (e) {}
              cacheVideoResource(media.url);
            }
          } catch (err) {}
        }
      })();
      cachedModalVideo.id = "zoomVideo";
      // set poster when available so modal shows a preview immediately on mobile
      try {
        cachedModalVideo.poster = media.previewUrl || media.preview_image || "";
      } catch (e) {}
      // Debug hooks: log play errors and state for easier diagnosis on mobile
      cachedModalVideo.addEventListener("play", () =>
        console.debug("lux video: modal play event"),
      );
      cachedModalVideo.addEventListener("playing", () =>
        console.debug("lux video: modal playing"),
      );
      cachedModalVideo.addEventListener("pause", () =>
        console.debug("lux video: modal paused"),
      );
      cachedModalVideo.addEventListener("error", (ev) => {
        console.warn("lux video: modal error event", ev);
      });
      wrapper.appendChild(cachedModalVideo);
      // try to play (may be blocked if browser policies apply)
      try {
        cachedModalVideo.play().catch(() => {});
      } catch (e) {}

      // Mobile browsers often block autoplay even in modals — ensure the poster/controls are visible
      // If the video fails to load or remains paused, reveal poster fallback so user can tap Play.
      const loadTimeout = setTimeout(() => {
        try {
          if (cachedModalVideo.readyState < 2 || cachedModalVideo.paused) {
            // reveal poster/controls
            cachedModalVideo.style.opacity = "1";
            // create fallback image if no poster shown by browser
            try {
              const poster =
                cachedModalVideo.poster ||
                media.previewUrl ||
                media.preview_image ||
                "";
              if (poster) {
                const existingFallback = wrapper.querySelector(
                  ".lux-modal-poster-fallback",
                );
                if (!existingFallback) {
                  const img = document.createElement("img");
                  img.src = poster;
                  img.alt = media.alt || "";
                  img.className = "lux-modal-poster-fallback";
                  img.style.width = "100%";
                  img.style.height = "100%";
                  img.style.objectFit = "contain";
                  img.style.position = "absolute";
                  img.style.inset = "0";
                  // IMPORTANT: don't block pointer events so touch/swipe reach the wrapper
                  img.style.pointerEvents = "none";
                  img.style.zIndex = "0";
                  wrapper.appendChild(img);
                }
                // allow tapping the wrapper to attempt to play the video (tap-to-play)
                try {
                  const tryPlay = () => {
                    if (!cachedModalVideo) return;
                    try {
                      const p =
                        cachedModalVideo.play && cachedModalVideo.play();
                      if (p && typeof p.then === "function") {
                        p.then(() =>
                          console.debug("lux video: play promise resolved"),
                        ).catch((err) => {
                          console.warn("lux video: play promise rejected", err);
                          // show controls as a fallback so user can tap
                          try {
                            cachedModalVideo.controls = true;
                          } catch (e) {}
                          try {
                            cachedModalVideo.style.opacity = "1";
                          } catch (e) {}
                        });
                      }
                    } catch (e) {
                      console.warn("lux video: play call failed", e);
                    }
                  };

                  // Robust tap-to-play that doesn't block swipe/pan gestures.
                  // Detect short taps (no meaningful movement) and trigger play.
                  let tapState = {
                    startX: null,
                    startY: null,
                    startT: null,
                    moved: false,
                  };
                  function onTapTouchStart(e) {
                    if (!e.touches || e.touches.length !== 1) return;
                    tapState.startX = e.touches[0].clientX;
                    tapState.startY = e.touches[0].clientY;
                    tapState.startT = Date.now();
                    tapState.moved = false;
                  }
                  function onTapTouchMove(e) {
                    if (
                      !tapState.startX ||
                      !e.touches ||
                      e.touches.length !== 1
                    )
                      return;
                    const dx = Math.abs(e.touches[0].clientX - tapState.startX);
                    const dy = Math.abs(e.touches[0].clientY - tapState.startY);
                    if (dx > 10 || dy > 10) tapState.moved = true;
                  }
                  function onTapTouchEnd(e) {
                    const dt = Date.now() - (tapState.startT || 0);
                    // short tap and no movement -> treat as tap
                    if (!tapState.moved && dt < 300) tryPlay();
                    tapState.startX = tapState.startY = tapState.startT = null;
                    tapState.moved = false;
                  }

                  // Also keep a click handler for non-touch environments
                  wrapper.addEventListener("click", tryPlay, { passive: true });
                  // Touch handlers: start needs passive:false to allow preventing if needed by other logic
                  wrapper.addEventListener("touchstart", onTapTouchStart, {
                    passive: false,
                  });
                  wrapper.addEventListener("touchmove", onTapTouchMove, {
                    passive: true,
                  });
                  wrapper.addEventListener("touchend", onTapTouchEnd, {
                    passive: true,
                  });

                  // Remove listeners once video has loaded data to avoid lingering handlers
                  once(cachedModalVideo, "loadeddata", function () {
                    try {
                      wrapper.removeEventListener("click", tryPlay);
                      wrapper.removeEventListener(
                        "touchstart",
                        onTapTouchStart,
                      );
                      wrapper.removeEventListener("touchmove", onTapTouchMove);
                      wrapper.removeEventListener("touchend", onTapTouchEnd);
                    } catch (e) {}
                  });
                } catch (e) {}
              }
            } catch (e) {}
          }
        } catch (e) {}
      }, 1000);

      // clear fallback if load succeeds
      once(cachedModalVideo, "loadeddata", function () {
        try {
          clearTimeout(loadTimeout);
        } catch (e) {}
      });
      // on error show poster fallback immediately
      cachedModalVideo.addEventListener("error", function () {
        try {
          cachedModalVideo.style.opacity = "1";
          const poster =
            cachedModalVideo.poster ||
            media.previewUrl ||
            media.preview_image ||
            "";
          if (poster) {
            const img = document.createElement("img");
            img.src = poster;
            img.alt = media.alt || "";
            img.className = "lux-modal-poster-fallback";
            img.style.width = "100%";
            img.style.height = "100%";
            img.style.objectFit = "contain";
            img.style.position = "absolute";
            img.style.inset = "0";
            img.style.pointerEvents = "none";
            img.style.zIndex = "0";
            wrapper.appendChild(img);
          }
        } catch (e) {}
      });
    }

    requestAnimationFrame(updateZoomTransform);

    if (counter) {
      counter.textContent = currentZoomIndex + 1 + " / " + product.media.length;
    }
  }

  function buildZoomThumbnails() {
    const product = window.luxuryProduct;
    const container = document.getElementById("zoomThumbnails");
    if (!product || !container) return;
    container.innerHTML = "";
    product.media.forEach((media, index) => {
      const thumb = document.createElement("button");
      thumb.className =
        "lux-zoom-thumb" + (index === currentZoomIndex ? " active" : "");
      const src = media.previewUrl || media.url || "";
      thumb.innerHTML = `<img src="${src}" alt="Thumbnail">`;
      thumb.addEventListener("click", function () {
        currentZoomIndex = index;
        resetZoom(false);
        updateZoomImage();
        updateZoomThumbnails();
        if (mainSwiper && typeof mainSwiper.slideTo === "function")
          mainSwiper.slideTo(index);
      });
      container.appendChild(thumb);
    });
    // Make thumbnails horizontally scrollable and swipeable on touch devices
    try {
      container.style.overflowX = "auto";
      container.style.WebkitOverflowScrolling = "touch";
      container.style.display = "flex";
      container.style.gap = "8px";
      container.style.padding = "8px 12px";
      container.style.touchAction = "pan-x";

      // Let native horizontal scrolling handle touch swipes for better UX.
      // The CSS `overflow-x: auto` + `touch-action: pan-x` allows smooth native swiping.
      let isDown = false;
      let startX = 0;
      let startScroll = 0;

      // Desktop drag-to-scroll support
      let mouseDown = false;
      container.addEventListener("mousedown", function (e) {
        // prevent parent from stealing mouse drag
        try {
          e.stopPropagation();
        } catch (er) {}
        mouseDown = true;
        startX = e.pageX;
        startScroll = container.scrollLeft;
        container.classList.add("lux-dragging");
        e.preventDefault();
      });
      window.addEventListener("mousemove", function (e) {
        if (!mouseDown) return;
        const x = e.pageX;
        const walk = startX - x;
        container.scrollLeft = startScroll + walk;
      });
      window.addEventListener("mouseup", function () {
        if (mouseDown) container.classList.remove("lux-dragging");
        mouseDown = false;
      });

      // Pointer events (recommended) - capture pointer to reliably track swipes
      try {
        let pointerActive = false;
        let pointerId = null;
        container.addEventListener("pointerdown", function (e) {
          // Only track primary pointers (finger/mouse)
          if (pointerActive) return;
          try {
            e.stopPropagation();
          } catch (er) {}
          pointerActive = true;
          pointerId = e.pointerId;
          startX = e.clientX;
          startScroll = container.scrollLeft;
          container.setPointerCapture && container.setPointerCapture(pointerId);
        });

        container.addEventListener("pointermove", function (e) {
          if (!pointerActive || e.pointerId !== pointerId) return;
          try {
            e.stopPropagation();
          } catch (er) {}
          const x = e.clientX;
          const walk = startX - x;
          if (Math.abs(walk) > 2) e.preventDefault();
          container.scrollLeft = startScroll + walk;
        });

        container.addEventListener("pointerup", function (e) {
          if (e.pointerId !== pointerId) return;
          try {
            e.stopPropagation();
          } catch (er) {}
          pointerActive = false;
          try {
            container.releasePointerCapture &&
              container.releasePointerCapture(pointerId);
          } catch (er) {}
          pointerId = null;
        });

        container.addEventListener("pointercancel", function (e) {
          if (e.pointerId !== pointerId) return;
          pointerActive = false;
          try {
            container.releasePointerCapture &&
              container.releasePointerCapture(pointerId);
          } catch (er) {}
          pointerId = null;
        });
      } catch (er) {
        // ignore pointer support failures
      }
    } catch (e) {
      // ignore environment where styling or events fail
    }
  }

  function updateZoomThumbnails() {
    const thumbs = document.querySelectorAll(".lux-zoom-thumb");
    thumbs.forEach((thumb, idx) =>
      thumb.classList.toggle("active", idx === currentZoomIndex),
    );
  }

  /* --------------------------------------------------------------------------
     Zoom interaction handlers
     - Pinch with two fingers to zoom in/out
     - Drag with one finger while zoomed
     - Double-tap / double-click to toggle zoom
     - Mouse wheel / trackpad zoom on desktop
     -------------------------------------------------------------------------- */
  let startRef = { x: 0, y: 0 };
  let startTranslateRef = { x: 0, y: 0 };
  let swipeStart = null;

  function getZoomImageElement() {
    const wrapper = document.getElementById("zoomImageWrapper");
    return wrapper ? wrapper.querySelector(".lux-zoom-image") : null;
  }

  function resetZoom(animate = true) {
    zoomScale = MIN_ZOOM;
    zoomTranslate = { x: 0, y: 0 };
    isPanning = false;
    isZoomGestureActive = !animate;
    lastTouchDistance = null;
    gestureWasPinch = false;
    gestureMoved = false;
    updateZoomTransform();
    isZoomGestureActive = false;
  }

  function clampZoomTranslate() {
    const wrapper = document.getElementById("zoomImageWrapper");
    const img = getZoomImageElement();

    if (!wrapper || !img || zoomScale <= MIN_ZOOM + 0.001) {
      zoomTranslate = { x: 0, y: 0 };
      return;
    }

    const scaledWidth = img.offsetWidth * zoomScale;
    const scaledHeight = img.offsetHeight * zoomScale;
    const maxX = Math.max(0, (scaledWidth - wrapper.clientWidth) / 2);
    const maxY = Math.max(0, (scaledHeight - wrapper.clientHeight) / 2);

    zoomTranslate.x = Math.min(maxX, Math.max(-maxX, zoomTranslate.x));
    zoomTranslate.y = Math.min(maxY, Math.max(-maxY, zoomTranslate.y));
  }

  function zoomAtPoint(nextScale, clientX, clientY) {
    const wrapper = document.getElementById("zoomImageWrapper");
    const img = getZoomImageElement();
    if (!wrapper || !img) return;

    const previousScale = zoomScale;
    const boundedScale = Math.min(
      MAX_ZOOM,
      Math.max(MIN_ZOOM, nextScale),
    );

    const rect = wrapper.getBoundingClientRect();
    const pointX =
      typeof clientX === "number"
        ? clientX - (rect.left + rect.width / 2)
        : 0;
    const pointY =
      typeof clientY === "number"
        ? clientY - (rect.top + rect.height / 2)
        : 0;

    if (previousScale > 0 && boundedScale !== previousScale) {
      const ratio = boundedScale / previousScale;
      zoomTranslate.x =
        pointX - (pointX - zoomTranslate.x) * ratio;
      zoomTranslate.y =
        pointY - (pointY - zoomTranslate.y) * ratio;
    }

    zoomScale = boundedScale;

    if (zoomScale <= MIN_ZOOM + 0.01) {
      zoomScale = MIN_ZOOM;
      zoomTranslate = { x: 0, y: 0 };
    }

    clampZoomTranslate();
    updateZoomTransform();
  }

  function handleTouchStart(e) {
    const img = getZoomImageElement();
    if (!img) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      isZoomGestureActive = true;
      isPanning = false;
      gestureWasPinch = true;
      gestureMoved = true;
      lastTouchDistance = getDistance(e.touches[0], e.touches[1]);
      swipeStart = null;
      updateZoomTransform();
      return;
    }

    if (e.touches.length === 1) {
      const touch = e.touches[0];
      startRef = { x: touch.clientX, y: touch.clientY };
      startTranslateRef = { ...zoomTranslate };
      swipeStart = { x: touch.clientX, y: touch.clientY };
      isPanning = zoomScale > MIN_ZOOM + 0.01;
      isZoomGestureActive = isPanning;
      gestureWasPinch = false;
      gestureMoved = false;
      updateZoomTransform();
    }
  }

  function handleTouchMove(e) {
    const img = getZoomImageElement();
    if (!img) return;

    if (e.touches.length === 2) {
      e.preventDefault();

      const newDistance = getDistance(e.touches[0], e.touches[1]);
      const midpoint = getMidpoint(e.touches[0], e.touches[1]);

      if (lastTouchDistance && lastTouchDistance > 0) {
        const ratio = newDistance / lastTouchDistance;
        zoomAtPoint(zoomScale * ratio, midpoint.x, midpoint.y);
      }

      lastTouchDistance = newDistance;
      gestureWasPinch = true;
      gestureMoved = true;
      return;
    }

    if (e.touches.length === 1) {
      const touch = e.touches[0];
      const dx = touch.clientX - startRef.x;
      const dy = touch.clientY - startRef.y;

      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        gestureMoved = true;
      }

      if (isPanning && zoomScale > MIN_ZOOM + 0.01) {
        e.preventDefault();
        zoomTranslate = {
          x: startTranslateRef.x + dx,
          y: startTranslateRef.y + dy,
        };
        clampZoomTranslate();
        updateZoomTransform();
      }
    }
  }

  function handleTouchEnd(e) {
    // Continue panning smoothly when a two-finger pinch becomes one finger.
    if (e.touches && e.touches.length === 1 && gestureWasPinch) {
      const touch = e.touches[0];
      startRef = { x: touch.clientX, y: touch.clientY };
      startTranslateRef = { ...zoomTranslate };
      isPanning = zoomScale > MIN_ZOOM + 0.01;
      lastTouchDistance = null;
      return;
    }

    if (e.touches && e.touches.length > 0) return;

    const changed =
      e.changedTouches && e.changedTouches.length
        ? e.changedTouches[0]
        : null;

    // Swipe between images only when the current image is not zoomed.
    if (
      !gestureWasPinch &&
      zoomScale === MIN_ZOOM &&
      swipeStart &&
      changed
    ) {
      const dx = changed.clientX - swipeStart.x;
      const dy = changed.clientY - swipeStart.y;

      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        navigateZoom(dx < 0 ? 1 : -1);
        gestureMoved = true;
      }
    }

    // Mobile double-tap zoom. Native dblclick is unreliable on iOS/Android.
    if (!gestureWasPinch && !gestureMoved && changed) {
      const now = Date.now();
      const tapDistance = Math.hypot(
        changed.clientX - lastTap.x,
        changed.clientY - lastTap.y,
      );

      if (now - lastTap.time < 320 && tapDistance < 40) {
        e.preventDefault();
        toggleZoom(changed.clientX, changed.clientY);
        lastTap = { time: 0, x: 0, y: 0 };
      } else {
        lastTap = {
          time: now,
          x: changed.clientX,
          y: changed.clientY,
        };
      }
    }

    if (zoomScale <= MIN_ZOOM + 0.01) {
      zoomScale = MIN_ZOOM;
      zoomTranslate = { x: 0, y: 0 };
    }

    lastTouchDistance = null;
    isPanning = false;
    isZoomGestureActive = false;
    gestureWasPinch = false;
    gestureMoved = false;
    swipeStart = null;
    clampZoomTranslate();
    updateZoomTransform();
  }

  function toggleZoom(clientX, clientY) {
    if (!getZoomImageElement()) return;

    if (zoomScale > MIN_ZOOM + 0.01) {
      resetZoom(true);
    } else {
      zoomAtPoint(DOUBLE_TAP_ZOOM, clientX, clientY);
    }
  }

  function handleDoubleClick(e) {
    e.preventDefault();
    toggleZoom(e.clientX, e.clientY);
  }

  function handleWheel(e) {
    if (!getZoomImageElement()) return;

    e.preventDefault();
    isZoomGestureActive = true;

    const multiplier = e.deltaY < 0 ? 1.14 : 0.88;
    zoomAtPoint(zoomScale * multiplier, e.clientX, e.clientY);

    window.clearTimeout(handleWheel.endTimer);
    handleWheel.endTimer = window.setTimeout(function () {
      isZoomGestureActive = false;
      updateZoomTransform();
    }, 100);
  }

  function updateZoomTransform() {
    const wrapper = document.getElementById("zoomImageWrapper");
    const modal = document.getElementById("imageZoomModal");
    const img = getZoomImageElement();
    if (!wrapper) return;

    const isZoomed = zoomScale > MIN_ZOOM + 0.01;
    wrapper.classList.toggle("is-zoomed", isZoomed);
    wrapper.classList.toggle("is-gesturing", isZoomGestureActive);
    modal && modal.classList.toggle("is-zoomed", isZoomed);

    if (!img) return;

    clampZoomTranslate();

    img.style.transform =
      "translate3d(" +
      zoomTranslate.x +
      "px, " +
      zoomTranslate.y +
      "px, 0) scale(" +
      zoomScale +
      ")";
    img.style.transformOrigin = "center center";
    img.style.willChange = "transform";
  }

  function getDistance(t1, t2) {
    const dx = t1.clientX - t2.clientX;
    const dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getMidpoint(t1, t2) {
    return {
      x: (t1.clientX + t2.clientX) / 2,
      y: (t1.clientY + t2.clientY) / 2,
    };
  }

  /* --------------------------------------------------------------------------
     Per-slide video handling: create stable video elements for slide usage,
     and auto-play/pause videos only when their slide is visible (IntersectionObserver
     + Swiper slideChange sync)
     -------------------------------------------------------------------------- */
  // Create video element with optimal attributes for inline autoplay
  function createSlideVideo(src, poster) {
    const video = document.createElement("video");
    video.className = "lux-slide-video";
    // Prefer a cached blob URL when available, otherwise use remote src and cache in background
    (async () => {
      try {
        const blobUrl = await getCachedBlobUrl(src);
        if (blobUrl) {
          video.src = blobUrl;
        } else {
          video.src = src;
          // Start caching in background (don't await)
          cacheVideoResource(src);
        }
      } catch (e) {
        video.src = src;
        cacheVideoResource(src);
      }
    })();
    // allow cross-origin decoding if server supports CORS
    try {
      video.crossOrigin = "anonymous";
    } catch (e) {}
    video.muted = true;
    video.loop = true;
    video.preload = "auto";
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    // Use poster to show preview before decoded frame
    if (poster) video.poster = poster;
    video.style.objectFit = "cover";
    // Smooth fade-in when first decoded to avoid blurred first-frame
    video.style.opacity = "0";
    video.style.transition = "opacity 220ms ease";

    const reveal = async () => {
      try {
        if (typeof video.decode === "function") {
          await video.decode();
        } else {
          // fallback small delay to allow browser to decode
          await new Promise((r) => setTimeout(r, 60));
        }
      } catch (e) {
        // ignore decode errors (CORS/codecs)
      } finally {
        video.style.opacity = "1";
        try {
          video.play().catch(() => {});
        } catch (e) {}
      }
    };

    // Attempt reveal once we have some data
    video.addEventListener("loadeddata", function onld() {
      video.removeEventListener("loadeddata", onld);
      reveal();
    });
    // Safety: also trigger after metadata if loadeddata doesn't fire
    video.addEventListener("loadedmetadata", function onmeta() {
      video.removeEventListener("loadedmetadata", onmeta);
      setTimeout(reveal, 30);
    });

    return video;
  }

  // Reveal logic for any video element (existing or created)
  function revealVideoElement(video) {
    if (!video) return;
    // ensure style and transition exist
    if (!video.style) video.style = {};
    video.style.transition = video.style.transition || "opacity 220ms ease";
    // hide initially if not already hidden
    if (!video.style.opacity) video.style.opacity = "0";

    const doReveal = async () => {
      try {
        if (typeof video.decode === "function") await video.decode();
        else await new Promise((r) => setTimeout(r, 60));
      } catch (e) {
        // ignore
      }

      try {
        const p = video.play && video.play();
        if (p && typeof p.then === "function") p.catch(() => {});
      } catch (e) {}

      if (typeof video.requestVideoFrameCallback === "function") {
        try {
          video.requestVideoFrameCallback(() => {
            video.style.opacity = "1";
          });
        } catch (e) {
          video.style.opacity = "1";
        }
      } else {
        setTimeout(() => (video.style.opacity = "1"), 80);
      }
    };

    // If already has enough data, reveal now
    if (video.readyState >= 2) {
      doReveal();
    } else {
      once(video, "loadeddata", doReveal);
      once(video, "loadedmetadata", () => setTimeout(doReveal, 30));
    }
  }

  // Observe slide visibility and play/pause accordingly
  function syncSlideVideoPlayback(activeIndex) {
    // Pause videos on non-active slides, play on active
    const slides = document.querySelectorAll(
      "#productMainSwiper .swiper-slide, .lux-slide",
    );
    slides.forEach((slide, idx) => {
      const video = slide.querySelector("video");
      if (!video) return;
      if (idx === activeIndex) {
        // attempt play (muted -> autoplay allowed)
        try {
          video.play().catch(() => {});
        } catch (e) {}
      } else {
        try {
          video.pause();
          // keep currentTime at small positive to keep decode cached frame
        } catch (e) {}
      }
    });
  }

  /* --------------------------------------------------------------------------
     Add to Cart — AJAX behavior unchanged but made a bit safer
     -------------------------------------------------------------------------- */
  function initAddToCart() {
    const form = document.querySelector("[data-product-form]");
    if (!form) return;

    form.addEventListener("submit", async function (e) {
      const submitBtn = e.submitter;
      const isBuyNow = submitBtn && submitBtn.hasAttribute("data-buy-now-btn");
      e.preventDefault();
      const variantId = form.querySelector("[data-variant-id]").value;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          }),
        });

        if (isBuyNow) {
          window.location.href = "/checkout";
          return;
        }
        openCartDrawer();
        updateCartCount();
      } catch (err) {
        console.error("Cart error:", err);
        alert("Failed to add to cart");
      }
    });
  }

  async function updateCartCount() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const countElements = document.querySelectorAll("[data-cart-count]");
      countElements.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "" : "none";
      });
    } catch (error) {
      console.error("Error updating cart count:", error);
    }
  }

  /* --------------------------------------------------------------------------
     Cart Drawer: render & bind actions (kept from original but robustified)
     -------------------------------------------------------------------------- */
  function openCartDrawer() {
    const drawer = document.getElementById("cart-drawer-luxury");
    if (drawer) {
      drawer.classList.add("is-active");
      document.body.style.overflow = "hidden";
      renderCartItems();
    }
  }

  function closeCartDrawer() {
    const drawer = document.getElementById("cart-drawer-luxury");
    if (drawer) {
      drawer.classList.remove("is-active");
      document.body.style.overflow = "";
    }
  }

  async function renderCartItems() {
    const container = document.querySelector("[data-cart-items-luxury]");
    const emptyState = document.querySelector("[data-cart-empty-luxury]");
    const filledState = document.querySelector("[data-cart-filled-luxury]");
    const totalEl = document.querySelector("[data-cart-total-luxury]");
    if (!container) return;
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      if (cart.item_count === 0) {
        if (emptyState) emptyState.style.display = "flex";
        if (filledState) filledState.style.display = "none";
        container.innerHTML = "";
        return;
      }
      if (emptyState) emptyState.style.display = "none";
      if (filledState) filledState.style.display = "flex";

      container.innerHTML = cart.items
        .map((item, index) => {
          return `
          <div class="cart-item-luxury" data-line-item="${index + 1}">
            <div class="cart-item-luxury__image">
              ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ""}
            </div>
            <div class="cart-item-luxury__details">
              <h3 class="cart-item-luxury__title">${item.product_title}</h3>
              <p class="cart-item-luxury__variant">${item.variant_title || ""}</p>
              <div class="cart-item-luxury__price-row">
                <p class="cart-item-luxury__price">${formatMoney(item.final_line_price)}</p>
                ${
                  item.quantity > 1
                    ? `<p class="cart-item-luxury__each">${formatMoney(item.final_price)} each</p>`
                    : ""
                }
              </div>
            </div>
            <div class="cart-item-luxury__actions">
              <div class="cart-item-luxury__quantity">
                <button type="button" class="cart-qty-btn" data-action="decrease" data-line="${
                  index + 1
                }" ${item.quantity <= 1 ? "disabled" : ""}>
                  - 
                </button>
                <span class="cart-qty-value">${item.quantity}</span>
                <button type="button" class="cart-qty-btn" data-action="increase" data-line="${
                  index + 1
                }">+</button>
              </div>
              <button type="button" class="cart-remove-btn" data-action="remove" data-line="${
                index + 1
              }">Remove</button>
            </div>
          </div>`;
        })
        .join("");

      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      bindCartItemActions();
    } catch (error) {
      console.error("Error rendering cart:", error);
    }
  }

  function bindCartItemActions() {
    const buttons = document.querySelectorAll("[data-action]");
    // remove duplicates by cloning
    buttons.forEach((btn) => {
      const clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);
    });

    const freshButtons = document.querySelectorAll("[data-action]");
    freshButtons.forEach((btn) => {
      btn.addEventListener("click", async function () {
        const action = this.dataset.action;
        const line = parseInt(this.dataset.line, 10);
        let updates = {};
        const itemEl = this.closest(".cart-item-luxury");
        const qtyEl = itemEl ? itemEl.querySelector(".cart-qty-value") : null;
        const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

        if (action === "remove") updates = { line: line, quantity: 0 };
        else if (action === "decrease")
          updates = { line: line, quantity: Math.max(0, currentQty - 1) };
        else if (action === "increase")
          updates = { line: line, quantity: currentQty + 1 };

        try {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updates),
          });
          renderCartItems();
          updateCartCount();
        } catch (error) {
          console.error("Error updating cart:", error);
        }
      });
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "INR";
    if (currency === "INR") return "₹" + amount;
    if (currency === "USD") return "$" + amount;
    if (currency === "EUR") return "€" + amount;
    if (currency === "GBP") return "£" + amount;
    return currency + " " + amount;
  }

  /* --------------------------------------------------------------------------
     Utility: when product area mounts, ensure slide video elements are created
     - If your Liquid outputs <div class="lux-slide" data-media-type="video" data-media-src="...">,
       this will convert those placeholders into proper <video> elements, with posters where provided.
     -------------------------------------------------------------------------- */
  function ensureSlideVideos() {
    const videoPlaceholders = document.querySelectorAll(
      ".lux-slide[data-media-type='video']",
    );
    videoPlaceholders.forEach((ph) => {
      if (ph.querySelector("video")) return;
      const src = ph.dataset.mediaSrc;
      const poster = ph.dataset.mediaPoster || ph.dataset.preview || "";
      if (!src) return;
      const v = createSlideVideo(src, poster);
      // Ensure we don't auto-play all — IntersectionObserver handles playback.
      ph.appendChild(v);
      // Reveal created element (in case it was hidden by CSS)
      revealVideoElement(v);
    });

    // Also handle existing video elements (theme may already output <video> tags)
    const existingVideos = document.querySelectorAll(
      ".lux-slide video, video.lux-slide-video",
    );
    existingVideos.forEach((vid) => {
      // ensure it has the class for consistent styling
      if (!vid.classList.contains("lux-slide-video"))
        vid.classList.add("lux-slide-video");
      // Try to replace src with cached blob URL if available, then reveal
      (async () => {
        try {
          const src = vid.currentSrc || vid.src;
          // prefer replacing <source> children if present (keeps source ordering)
          const sources = Array.from(vid.querySelectorAll("source"));
          if (sources.length) {
            let replaced = false;
            for (const s of sources) {
              const sUrl = s.getAttribute("src");
              if (!sUrl) continue;
              const blobUrl = await getCachedBlobUrl(sUrl);
              if (blobUrl) {
                s.setAttribute("src", blobUrl);
                replaced = true;
              } else {
                // start caching in background
                cacheVideoResource(sUrl);
              }
            }
            if (replaced) {
              try {
                vid.load();
              } catch (e) {}
            }
          } else if (src) {
            const blobUrl = await getCachedBlobUrl(src);
            if (blobUrl) {
              const ct = vid.currentTime || 0;
              vid.src = blobUrl;
              try {
                vid.currentTime = ct;
              } catch (e) {}
            } else {
              if (src) cacheVideoResource(src);
            }
          }
        } catch (e) {
          // ignore
        } finally {
          revealVideoElement(vid);
        }
      })();
    });

    // Use IntersectionObserver to auto-play visible videos (for non-Swiper fallback)
    try {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const vid = entry.target.querySelector("video");
            if (!vid) return;
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              try {
                vid.play().catch(() => {});
              } catch (e) {}
            } else {
              try {
                vid.pause();
              } catch (e) {}
            }
          });
        },
        { threshold: [0.5, 0.75] },
      );

      document
        .querySelectorAll(".lux-slide")
        .forEach((slide) => io.observe(slide));
    } catch (e) {
      // IntersectionObserver not supported — don't break functionality
    }
  }

  // Call ensureSlideVideos shortly after DOM ready so Liquid placeholders are present
  raf(() => raf(ensureSlideVideos));

  /* --------------------------------------------------------------------------
     When a slide is visible in Swiper, play/pause is maintained via syncSlideVideoPlayback
     But for non-swiper flows we still ensure visibility control above.
     -------------------------------------------------------------------------- */

  // Initialize once
  init();

  // Expose helper to open zoom modal programmatically
  window.openZoomModal = openZoomModal;

  // Sync video playback for Swiper when slides change externally (public)
  window.syncSlideVideoPlayback = syncSlideVideoPlayback;
})();




/* ========================================================================
   MOBILE PRODUCT INFORMATION ACCORDION
   Converts the existing tabs into H&M / Zara-style disclosure rows on
   mobile, while leaving the desktop tabs and all gallery logic unchanged.
   ======================================================================== */
(function () {
  "use strict";

  const mobileQuery = window.matchMedia("(max-width: 767px)");

  function getLabel(button, fallback) {
    if (!button) return fallback;

    const copy = button.cloneNode(true);
    copy.querySelectorAll(".lux-tab-indicator").forEach((node) => node.remove());
    return copy.textContent.trim() || fallback;
  }

  function openPanel(section, tabId) {
    const navButtons = Array.from(section.querySelectorAll(".lux-tabs-nav [data-tab]"));
    const panels = Array.from(section.querySelectorAll("[data-tab-panel]"));
    const triggers = Array.from(section.querySelectorAll("[data-lux-mobile-accordion]"));

    navButtons.forEach((button) => {
      button.classList.toggle("active", button.dataset.tab === tabId);
    });

    panels.forEach((panel) => {
      const isOpen = panel.dataset.tabPanel === tabId;
      panel.classList.toggle("active", isOpen);
      panel.classList.toggle("lux-mobile-open", isOpen);
      panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    });

    triggers.forEach((trigger) => {
      const isOpen = trigger.dataset.mobileTab === tabId;
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function closePanel(section, tabId) {
    const panel = section.querySelector(`[data-tab-panel="${tabId}"]`);
    const trigger = section.querySelector(`[data-lux-mobile-accordion][data-mobile-tab="${tabId}"]`);
    const navButton = section.querySelector(`.lux-tabs-nav [data-tab="${tabId}"]`);

    if (panel) {
      panel.classList.remove("active", "lux-mobile-open");
      panel.setAttribute("aria-hidden", "true");
    }

    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (navButton) navButton.classList.remove("active");
  }

  function initialiseAccordion(section) {
    if (section.dataset.luxMobileAccordionInitialised === "true") return;

    const navButtons = Array.from(section.querySelectorAll(".lux-tabs-nav [data-tab]"));
    const panels = Array.from(section.querySelectorAll("[data-tab-panel]"));

    if (!panels.length) return;

    panels.forEach((panel, index) => {
      const tabId = panel.dataset.tabPanel;
      const sourceButton = navButtons.find((button) => button.dataset.tab === tabId);
      const fallback = `Section ${index + 1}`;
      const label = getLabel(sourceButton, fallback);
      const trigger = document.createElement("button");

      trigger.type = "button";
      trigger.className = "lux-mobile-accordion-trigger";
      trigger.dataset.luxMobileAccordion = "true";
      trigger.dataset.mobileTab = tabId;
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("aria-controls", `lux-mobile-panel-${tabId}-${index}`);

      panel.id = panel.id || `lux-mobile-panel-${tabId}-${index}`;
      panel.setAttribute("aria-hidden", "true");

      const labelElement = document.createElement("span");
      labelElement.textContent = label;

      const icon = document.createElement("span");
      icon.className = "lux-mobile-accordion-icon";
      icon.setAttribute("aria-hidden", "true");

      trigger.append(labelElement, icon);
      panel.before(trigger);

      trigger.addEventListener("click", function () {
        const isOpen = trigger.getAttribute("aria-expanded") === "true";

        if (isOpen) {
          closePanel(section, tabId);
          return;
        }

        openPanel(section, tabId);
      });
    });

    section.dataset.luxMobileAccordionInitialised = "true";

    const initiallyActive =
      panels.find((panel) => panel.classList.contains("active")) || panels[0];

    if (initiallyActive) {
      openPanel(section, initiallyActive.dataset.tabPanel);
    }
  }

  function destroyAccordion(section) {
    if (section.dataset.luxMobileAccordionInitialised !== "true") return;

    section.querySelectorAll("[data-lux-mobile-accordion]").forEach((trigger) => {
      trigger.remove();
    });

    const panels = Array.from(section.querySelectorAll("[data-tab-panel]"));
    const navButtons = Array.from(section.querySelectorAll(".lux-tabs-nav [data-tab]"));
    const activeNav = navButtons.find((button) => button.classList.contains("active"));
    const activeId = activeNav?.dataset.tab || panels[0]?.dataset.tabPanel;

    panels.forEach((panel) => {
      panel.classList.remove("lux-mobile-open");
      panel.removeAttribute("aria-hidden");
      panel.classList.toggle("active", panel.dataset.tabPanel === activeId);
    });

    delete section.dataset.luxMobileAccordionInitialised;
  }

  function syncAccordionMode() {
    document.querySelectorAll(".lux-tabs-section").forEach((section) => {
      if (mobileQuery.matches) {
        initialiseAccordion(section);
      } else {
        destroyAccordion(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAccordionMode);
  } else {
    syncAccordionMode();
  }

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncAccordionMode);
  } else if (typeof mobileQuery.addListener === "function") {
    mobileQuery.addListener(syncAccordionMode);
  }

  document.addEventListener("shopify:section:load", syncAccordionMode);
})();

/* ========================================================================
   MOBILE RELATED PRODUCT SWIPER
   Uses the Swiper library already loaded by the product gallery.
   ======================================================================== */
(function () {
  "use strict";

  const mobileQuery = window.matchMedia("(max-width: 767px)");

  function initialiseOne(section) {
    const element = section.querySelector("[data-lux-related-swiper]");
    if (!element || typeof Swiper === "undefined") return;

    if (!mobileQuery.matches) {
      if (element.luxRelatedSwiper) {
        element.luxRelatedSwiper.destroy(true, true);
        element.luxRelatedSwiper = null;
      }
      return;
    }

    if (element.luxRelatedSwiper) {
      element.luxRelatedSwiper.update();
      return;
    }

    const previousButton = section.querySelector("[data-lux-related-previous]");
    const nextButton = section.querySelector("[data-lux-related-next]");
    const pagination = section.querySelector("[data-lux-related-pagination]");

    element.luxRelatedSwiper = new Swiper(element, {
      slidesPerView: 1.42,
      spaceBetween: 10,
      speed: 520,
      loop: false,
      watchOverflow: true,
      grabCursor: true,
      resistanceRatio: 0.72,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      pagination: pagination
        ? {
            el: pagination,
            type: "progressbar",
          }
        : undefined,
      breakpoints: {
        390: {
          slidesPerView: 1.55,
          spaceBetween: 10,
        },
        520: {
          slidesPerView: 2.15,
          spaceBetween: 12,
        },
      },
    });
  }

  function initialiseAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const sections = [];

    if (scope.matches && scope.matches("[data-lux-related-section]")) {
      sections.push(scope);
    }

    scope.querySelectorAll("[data-lux-related-section]").forEach((section) => {
      if (!sections.includes(section)) sections.push(section);
    });

    sections.forEach(initialiseOne);
  }

  function waitForSwiper(root, attempt) {
    if (typeof Swiper !== "undefined") {
      initialiseAll(root);
      return;
    }

    if (attempt < 80) {
      window.setTimeout(function () {
        waitForSwiper(root, attempt + 1);
      }, 60);
    }
  }

  window.initLuxRelatedProductSwipers = function (root) {
    waitForSwiper(root || document, 0);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      waitForSwiper(document, 0);
    });
  } else {
    waitForSwiper(document, 0);
  }

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", function () {
      initialiseAll(document);
    });
  } else if (typeof mobileQuery.addListener === "function") {
    mobileQuery.addListener(function () {
      initialiseAll(document);
    });
  }

  document.addEventListener("shopify:section:load", function (event) {
    waitForSwiper(event.target || document, 0);
  });
})();